import imagen1 from "../../assets/bruxismo_11.jpg"
import imagen2 from "../../assets/bruxismo_4.jpg"
import imagen3 from "../../assets/bruxismo_11.jpg"
import imagen4 from "../../assets/bruxismo 2.jpg"
import imagen5 from "../../assets/contorno_1.jpg"
import imagen6 from "../../assets/contorno_2.jpg"
import imagen7 from "../../assets/contorno.jpg"
import imagen8 from "../../assets/enzimas_3.jpg"
import imagen9 from "../../assets/enzimas_1.jpg"
import imagen10 from "../../assets/enzimas_3.jpg"
import imagen11 from "../../assets/facial_2.jpg"
import imagen12 from "../../assets/facial_4.jpg"
import imagen13 from "../../assets/facial_3.jpg"
import imagen14 from "../../assets/colageno_2.jpg"
import imagen15 from "../../assets/facial_1.jpg"
import imagen16 from "../../assets/colageno_1.jpg"
import imagen17 from "../../assets/hidratacion.jpg"
import imagen18 from "../../assets/hidratacion_1.jpg"
import imagen19 from "../../assets/hidratacion_2.jpg"
import imagen20 from "../../assets/facial_22.jpg"
import imagen21 from "../../assets/hiperhidrosis.jpg"
import imagen22 from "../../assets/facial_25.jpg"
import imagen23 from "../../assets/hydrafacial.jpg"
import imagen24 from "../../assets/hydrafacial_2.jpg"
import imagen25 from "../../assets/hydrafacial_3.jpg"
import imagen26 from "../../assets/limpieza.jpg"
import imagen27 from "../../assets/limpieza_2.jpg"
import imagen28 from "../../assets/facial_18.jpg"
import imagen29 from "../../assets/facial_30.jpg"
import imagen30 from "../../assets/labios_2.jpg"
import imagen31 from "../../assets/facial_32.jpg"
import imagen32 from "../../assets/facial_8.jpg"
import imagen33 from "../../assets/facial_40.jpg"
import imagen34 from "../../assets/facial_9.jpg"
import imagen35 from "../../assets/facial_35.jpg"
import imagen36 from "../../assets/facial_33.jpg"
import imagen37 from "../../assets/facial_34.jpg"
import imagen38 from "../../assets/ojeras.jpg"
import imagen39 from "../../assets/ojeras_1.jpg"
import imagen40 from "../../assets/ojeras_3.jpg"
import imagen41 from "../../assets/peeling_2.jpg"
import imagen42 from "../../assets/peeling_4.jpg"
import imagen43 from "../../assets/peeling_3.jpg"
import imagen44 from "../../assets/facial_16.jpg"
import imagen45 from "../../assets/pomulos.jpg"
import imagen46 from "../../assets/facial_39.jpg"
import imagen47 from "../../assets/plasma_1.jpg"
import imagen48 from "../../assets/plasma_3.jpg"
import imagen49 from "../../assets/plasma.jpg"
import imagen50 from "../../assets/acido.jpg"
import imagen51 from "../../assets/acido_2.jpg"
import imagen52 from "../../assets/acido_3.jpg"
import imagen53 from "../../assets/rinomodelacion.jpg"
import imagen54 from "../../assets/rinomodelacion_2.jpg"
import imagen55 from "../../assets/rinomodelacion_3.jpg"
import imagen56 from "../../assets/surcos_2.jpg"
import imagen57 from "../../assets/surcos_3.jpg"
import imagen58 from "../../assets/surcos.jpg"
import imagen59 from "../../assets/sustentacion_1.jpg"
import imagen60 from "../../assets/sustentacion_2.jpg"
import imagen61 from "../../assets/sustentacion_3.jpg"
import imagen62 from "../../assets/botulinica_1.jpg"
import imagen63 from "../../assets/botulinica_2.jpg"
import imagen64 from "../../assets/botulinica_3.jpg"
import imagen65 from "../../assets/radiofrecuencia_1.jpg"
import imagen66 from "../../assets/radiofrecuencia_1.jpg"
import imagen67 from "../../assets/radiofrecuencia_3.jpg"
import imagen68 from "../../assets/radiofrecuencia_2.jpg"
import imagen69 from "../../assets/microagujas_1.jpg"
import imagen70 from "../../assets/microagujas_3.jpg"
import imagen71 from "../../assets/microagujas_2.jpg"
import imagen72 from "../../assets/fototerapia.jpg"
import imagen73 from "../../assets/fototerapia.jpg"
import imagen74 from "../../assets/fototerapia_1.jpg"
import imagen75 from "../../assets/fototerapia_3.jpg"
import imagen76 from "../../assets/enzimas_1.jpg"
import imagen77 from "../../assets/enzimas_2.jpg"
import imagen78 from "../../assets/enzimas.jpg"
import imagen79 from "../../assets/sueroterapia_3.jpg"
import imagen80 from "../../assets/sueroterapia_1.jpg"
import imagen81 from "../../assets/sueroterapia.jpg"
import imagen82 from "../../assets/tensamax_5.jpg"
import imagen83 from "../../assets/tensamax_6.jpg"
import imagen84 from "../../assets/tensamax_7.jpg"
import imagen85 from "../../assets/emsculpt_2.jpg"
import imagen86 from "../../assets/emsculpt_3.jpg"
import imagen87 from "../../assets/emsculpt.jpg"
import imagen88 from "../../assets/microcapilar.jpg"
import imagen89 from "../../assets/microcapilar_2.jpg"
import imagen90 from "../../assets/microcapilar_3.jpg"
import imagen91 from "../../assets/masaje.jpg"
import imagen92 from "../../assets/masaje_2.jpg"
import imagen93 from "../../assets/masaje_4.jpg"
import imagen94 from "../../assets/celulitis.jpg"
import imagen95 from "../../assets/celulitis_4.jpg"
import imagen96 from "../../assets/celulitis_3.jpg"
import imagen97 from "../../assets/maderoterapia_3.jpg"
import imagen98 from "../../assets/maderoterapia_4.jpg"
import imagen99 from "../../assets/maderoterapia.jpg"
import imagen100 from "../../assets/relajante_3.jpg"
import imagen101 from "../../assets/relajante_4.jpg"
import imagen102 from "../../assets/relajante_1.jpg"
import imagen103 from "../../assets/mesoterapia.jpg"
import imagen104 from "../../assets/mesoterapia_4.jpg"
import imagen105 from "../../assets/mesoterapia_3.jpg"
import imagen106 from "../../assets/plasma_capilar.jpg"
import imagen107 from "../../assets/mesocapilar_2.jpg"
import imagen108 from "../../assets/tratamiento_1.jpg"
import imagen109 from "../../assets/plasma_capilar_2.jpg"
import imagen110 from "../../assets/plasma_capilar_3.jpg"
import imagen111 from "../../assets/plasma_capilar_4.jpg"


// Datos de los servicios
export const serviciosData = {
  bruxismo: {
    id: "bruxismo",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Tratamiento del bruxismo (enfoque en el músculo masetero)",
    titulo1: "El bruxismo es un trastorno en el que se produce un apretamiento o rechinamiento inconsciente de los dientes. Esta condición puede generar molestias en la mandíbula, dolores de cabeza y un desgaste prematuro de las piezas dentales. Uno de los principales factores que contribuyen a este problema es la sobreactividad del músculo masetero, encargado de los movimientos de masticación.",
    pregunta: "¿Cómo funciona el tratamiento de bruxismo con toxina botulínica?",
    descripcion: "La aplicación de toxina botulínica para tratar el bruxismo implica la inyección de esta sustancia en el músculo masetero. Su acción principal es relajar el músculo, disminuyendo su capacidad de contraerse con fuerza. Esto no solo reduce los síntomas más comunes, como el dolor mandibular, las cefaleas y el deterioro dental, sino que también puede aportar un efecto estético al suavizar y afinar la línea de la mandíbula. Ventajas del tratamiento: Disminución de la tensión muscular en la mandíbula. Mejora significativa del dolor en la zona mandibular y de los dolores de cabeza. Protección de los dientes frente al desgaste causado por el bruxismo. Refinamiento del óvalo facial, aportando un aspecto más estilizado. Método mínimamente invasivo, con efectos visibles en poco tiempo. A tener en cuenta: Antes de optar por este tratamiento, es fundamental realizar una evaluación personalizada. Esto permitirá adaptar el procedimiento a las necesidades específicas de cada paciente, asegurando los mejores resultados.",
    imagenHero: imagen1,
    imagen1: imagen2,
    imagen2: imagen3,
    infoCards: [
      {
        sectionTitle: "1. Tratamiento de Bruxismo",
        cards: [
          { title: "Masetero", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "9 - 12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados posteriores al tratamiento con toxina botulínica para bruxismo",
      descripcion: "Este procedimiento es ambulatorio y no requiere tiempo de recuperación, ya que se realiza en consulta mediante microinyecciones. Sin embargo, para optimizar los resultados y minimizar efectos transitorios, se recomienda seguir estas pautas:",
      pasos: [
        {
          numero: "1",
          titulo:"Posición después del tratamiento",
          texto: "Evite reclinarse o acostarse durante las primeras 4 horas posteriores. Mantenerse en posición vertical ayuda a que la sustancia se distribuya adecuadamente en el músculo masetero."
        },
        {
          numero: "2",
          titulo:"Actividad física y exposición al calor",
          texto: "Suspenda ejercicios intensos, sesiones de sauna, baños de vapor o cualquier actividad que eleve la temperatura corporal durante las primeras 24 horas. Esto previene la dispersión accidental del producto."
        },
        {
          numero: "3",
          titulo:"Posibles reacciones temporales",
          texto: "En algunos casos, puede presentarse ligera inflamación o hematomas en la zona de aplicación, los cuales se resuelven espontáneamente en 48-72 horas. Se sugiere evitar el consumo de alcohol y antiinflamatorios el día del procedimiento para reducir este riesgo."
        },
      ],
      videoUrl: imagen4,
    }
  },
  "contorno-mandibular": {
    id: "contorno-mandibular",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Moldeado del óvalo facial con Ácido Hialurónico",
    titulo1: "Este tratamiento estético no invasivo está diseñado para recuperar la definición y armonía de la mandíbula, un elemento clave para proyectar un rostro equilibrado y rejuvenecido. Con el tiempo, factores como la edad o la pérdida de colágeno pueden difuminar estos rasgos, pero es posible restaurarlos sin cirugía.",
    pregunta: "¿Cómo se realiza el moldeado mandibular con Ácido Hialurónico?",
    descripcion: "<p>Mediante la aplicación estratégica de ácido hialurónico de alta densidad, se restauran volúmenes y se redefine la línea de la mandíbula. El procedimiento, realizado con microcánulas finas, es prácticamente indoloro y no requiere reposo. Además de devolver la estructura facial, estimula la hidratación y firmeza de la piel, atenuando líneas de expresión en la zona tratada.</p><p><strong>Beneficios destacados:</strong></p><ul><li>Recuperación de la simetría y proporción facial.</li><li>Efecto lifting natural sin incisiones.</li><li>Resultados visibles desde la primera sesión.</li><li>Estimulación de colágeno para una piel más elástica.</li><li>Duración promedio de 12-18 meses, según el metabolismo.</li></ul>",
    imagenHero: imagen4,
    imagen1: imagen5,
    imagen2: imagen6,
    infoCards: [
      {
        sectionTitle: "1. Moldeado Mandibular",
        cards: [
          { title: "Procedimiento", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "18 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Recomendaciones posteriores al tratamiento:",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Recomendaciones posteriores al tratamiento:",
          texto: "Durante las primeras 24 horas, absténgase de hacer ejercicio vigoroso, visitar saunas o tomar baños calientes para prevenir inflamación."
        },
        {
          numero: "2",
          titulo:"Manejo de efectos temporales:",
          texto: "Es común observar leves enrojecimientos o hematomas en el área, que desaparecen espontáneamente en 24-48 horas. Se sugiere aplicar compresas frías si hay inflamación."
        },
        {
          numero: "3",
          titulo:"Notas adicionales:",
          texto: "•Ideal para quienes buscan un perfil más angulado o corregir asimetrías.\n•Combina con otros tratamientos como bioestimuladores para potenciar resultados.\n•La Dra. Martínez Torrado personaliza cada protocolo según la anatomía y objetivos del paciente."
        },
      ],
      videoUrl: imagen7,
    }
  },
  
  "enzimas": {
    id: "enzimas",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "PBSerum: Solución Innovadora para Reducción de Grasa y Reafirmación Cutánea",
    titulo1: "Protocolo no invasivo basado en enzimas bioactivas de última generación, diseñado para tratar áreas específicas con resultados clínicamente comprobados.",
    pregunta: "¿Cómo actúa este tratamiento?",
    descripcion: "<ul>Las enzimas PBSerum trabajan mediante un enfoque triple:\n  <strong>1. Metabolismo de adipocitos:</strong> Degrada depósitos grasos localizados (como abdomen o papada).\n<strong>2. Estimulación colágena:</strong> Mejora la elasticidad de la piel en zonas con flacidez.\n<strong>3. Modulación fibrótica:</strong> Reduce la apariencia de cicatrices gruesas y queloides.\n<strong>Proceso del tratamiento:</strong>\n<li>Evaluación inicial: Estudio personalizado para determinar zonas objetivo (realizado el mismo día).\n<li>Aplicación: Microinyecciones indoloras con anestesia tópica (20 minutos por sesión).</li>\n<li>Resultados progresivos: Primeros cambios visibles a las 2-4 semanas, con efecto máximo a los 3 meses.</li>\n<strong>Recomendaciones postratamiento:</strong>\n<li>Reposo físico de 24 horas (evitar ejercicio intenso, saunas o piscinas).</li>\n<li>Seguir una dieta baja en grasas durante 15 días.</li>\n<li>Hidratación constante para potenciar la regeneración tisular.</li>\n<strong>Aspectos clave:</strong>\n<li>No apto durante embarazo, lactancia o procesos infecciosos activos.</li>\n<li>Número de sesiones: 1 a 3 (definidas en consulta médica).</li>\n<li>Alternativa eficaz a métodos quirúrgicos para remodelación corporal.</li></ul>",
    imagenHero: imagen7,
    imagen1: imagen8,
    imagen2: imagen9,
   infoCards: [
      {
        sectionTitle: "1. Tratamiento con Enzimas",
        cards: [
          { title: "Precio por sesión", value: " costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "20 min" },
          { title: "Resultados visibles", value: "De 15 a 30 días" },
          { title: "Anestesia", value: "Tópica" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Posteriores al Tratamiento con Enzimas",
      descripcion: "Los resultados óptimos se observan progresivamente entre la 2ª y 4ª semana postratamiento. Para garantizar su efectividad, sigue estas indicaciones:",
      pasos: [
        {
          numero: "1",
          titulo:"Reposo físico:",
          texto: "•Evita ejercicios intensos, levantamiento de peso o actividades deportivas durante <strong>24 horas posteriores.</strong>\n•Posterga saunas, piscinas climatizadas o baños de vapor por <strong>1 día completo."
        },
        {
          numero: "2",
          titulo:"Nutrición controlada:",
          texto: "• Mantén una alimentación reducida en lípidos y azúcares refinados durante <strong>15 días consecutivos.</strong>\n• Incrementa el consumo de agua y antioxidantes naturales (frutas cítricas, vegetales verdes)."
        },

        {
          numero: "3",
          titulo:"Monitorización:",
          texto: "• Programa seguimiento médico para evaluar avances y definir sesiones adicionales (si se requieren)."
        },

        {
          numero: "4",
          titulo:"Nota clave:",
          texto: "• La combinación de reposo + dieta potencia la acción enzimática y acelera la eliminación de adipocitos tratados."
        },
       
               
      ],
      videoUrl: imagen11,
    }
  },
  "exosomas": {
    id: "exosomas",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Terapia Regenerativa con Exosomas: Revitalización Integral de Piel y Cuero Cabelludo",
    titulo1: "Protocolo de vanguardia que combina nanotecnología y bioactivos para combatir el envejecimiento cutáneo y la disfunción capilar.",
    pregunta: "¿Cómo actúan los exosomas para regenerar tejidos?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>\nLos exosomas son <strong>vesículas nanométricas</strong> derivadas de células vegetales que funcionan como 'mensajeros biológicos'. Su mecanismo se basa en:\n
    <strong2>✓ Transporte de señales bioquímicas:</strong2> Liberan proteínas, ARN y lípidos que activan la autoreparación celular.
    <strong2>✓ Regulación inflamatoria:</strong2> Inhiben citocinas proinflamatorias, reduciendo rojeces e irritación.
    <strong2>✓ Estimulación de colágeno/queratina:</strong2> Optimizan la síntesis de fibras estructurales en piel y folículos pilosos.
    \n<strong>Protocolo de Tratamiento:</strong>\n <strong2>Composición exclusiva:</strong2>
    \n<strong>Beneficios Clínicos: </strong>\n<strong2>Para piel:</strong2>\n✓ Hidratación profunda y reducción de poros.\n✓ Corrección de hiperpigmentación (+60% efectividad).\n✓ Firmeza mejorada en 4-6 semanas.\n<strong2>Para cabello:</strong2>
✓ Reactivación de folículos dormidos (fase anágena).\n✓ Aumento de densidad capilar en 2-3 meses.✓ Protección contra la caída androgenética.\n
<strong2>Requisitos Clave:</strong2> <li><strong2>Evaluación previa:</strong2> Diagnóstico con dermatoscopia digital o tricoscopia.\n<li><Duración:><strong2>Duración:</strong2> 60-90 minutos (según técnica adjunta).</li><li><strong2>Cuidados Postratamiento:</strong2></i>\n✓ Evitar lavado facial o cosméticos × 24 h.\n✓ Reposo físico × 24 h.\n✓ Fotoprotección SPF 50+ diaria.</ul>`,
    imagenHero: imagen10,
    imagen1: imagen11,
    imagen2: imagen12,
    infoCards: [
      {
        sectionTitle: "1. Terapia con Exosomas",
        cards: [
          { title: "Exosomas", value: " costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "Variable segun canal" },
          { title: "Duración", value: "Variable" },
          { title: "Anestesia", value: "Dependiendo el canal de aplicación" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento:",
          texto: "✓ Evitar lavado facial o cosméticos × 24 h.\n✓ Reposo físico × 24 h.\n✓ Fotoprotección SPF 50+ diaria."
        },
        {
          numero: "2",
          titulo:"Contraindicaciones:",
          texto: "✓ Embarazo/lactancia.\n✓ Enfermedades autoinmunes activas."
        },
         
      ],
      videoUrl: imagen13,
    }
  },
"estimuladores-de-colageno": {
    id: "estimuladores-de-colageno",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Estimuladores de colageno: Bioestimulación Híbrida para Definición Facial y Efecto Lifting",
    titulo1: "Tratamiento innovador que combina hidroxiapatita de calcio y ácido hialurónico para corregir la flacidez y restaurar la armonía facial.",
    pregunta: "¿Cómo funcionan los Estimuladores de colageno?",
    descripcion: `<ul><strong>Mecanismo Dual de Acción:</strong>
<strong2>Hidroxiapatita de Calcio (50%):</strong2>
✓ Estimula la síntesis de colágeno tipo I y elastina.
✓ Genera un efecto tensor progresivo (2-6 meses).
✓ Refuerza la estructura dérmica.\n
<strong2>Ácido Hialurónico Reticulado:</strong2>
✓ Proporciona hidratación profunda y volumen inmediato.
✓ Define el óvalo facial (mandíbula, pómulos, línea media).
✓ Mejora la sustentación tisular.\n
<strong2>Beneficios Clave:</strong2>
✓ Resultados naturales sin apariencia sobrecorregida.
✓ Efecto lifting sin cirugía.
✓ Combinación de acción inmediata (10%) y progresiva (90%).
✓ Ideal para pacientes con pérdida de densidad cutánea.\n
<strong2>Protocolo de Aplicación:</strong2>
<strong2>• Técnica:</strong2> Microinyecciones estratégicas en planos profundos.
<strong2>• Duración:</strong2>30-45 minutos.
<strong2>• Resultados:</strong2>
<strong2>✓Inmediatos:</strong2> Volumen y definición por ácido hialurónico.
<strong2>✓ Progresivos:</strong2> Firmeza máxima a los 60 días.</ul>`,
    imagenHero: imagen13,
    imagen1: imagen14,
    imagen2: imagen15,
   infoCards: [
      {
        sectionTitle: "1. Tratamiento Estimuladores de colageno",
        cards: [
          { title: "Estimuladores de colageno", value: " costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "20 - 30 min" },
          { title: "Duración", value: "12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "✓ Evitar ejercicio físico intenso × 24 h (previene inflamación).\n✓ No exposición a saunas/piscinas × 24 h (evita edema).\n✓ Hidratación oral reforzada (2L agua/día × 72 h)."
        },
        {
          numero: "2",
          titulo:"Contraindicaciones",
          texto: "✓ Embarazo/lactancia.\n✓ Alergias a componentes del cóctel."
        },
         
      ],
      videoUrl: imagen16,
    }
  },
  "hidratación": {
    id: "hidratación",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Ritual de Hidratación Facial + Kobido: Fusión de Tecnología y Tradición",
    titulo1: "Protocolo dual que combina cosmética médica avanzada  para una revitalización facial integral.",
    pregunta: "Hidratación Profunda con Skinceuticals®/Casmara <br>  ¿Cómo actúa?",
    descripcion: `<ul><strong2>✓ Tecnología de infusión:</strong2> Almohadillas biocelulares cargadas con ácido hialurónico fragmentado penetran hasta la dermis reticular.
<strong2>✓ Target específico:</strong2> Corrige arrugas perioculares, surcos nasogenianos y flacidez cervical.
<strong2>✓ Adaptabilidad:</strong2> Fórmulas ajustables para pieles sensibles, grasas o maduras.

<h2>Masaje Kobido: El Arte Japonés del Rejuvenecimiento</h2>
<strong2>Técnica manual:</strong2>
<strong2>✓ Presiones rítmicas:</strong2> Activan drenaje linfático en rostro, cuello y escote.
<strong2>✓ Movimientos de tsuru-no-hitokoe:</strong2> Estiran el SMAS (músculo aponeurótico superficial) para efecto lifting instantáneo.
<strong2>✓ Liberación miofascial:</strong2> Reduce tensión en músculos masticadores y frontal.

<strong2>Beneficios Combinados</strong2>
✓ 85% más de hidratación que métodos convencionales (medido por corneometría).
✓ Reducción de edema en bolsas palpebrales (resultados en 20 minutos).
✓ Disminución de estrés oxidativo cutáneo (por medición de malondialdehído).</ul>`,
    imagenHero: imagen16,
    imagen1: imagen17,
    imagen2: imagen18,
   infoCards: [
      {
        sectionTitle: "1. Hidratación Facial Básica",
        cards: [
          {
            title: "Hidratación Facial (Productos Skinceuticals® / Casmara o Láminas de Oro)",
            value: " costo de acuerdo a valoración medica",
          },
          { title: "Duración", value: "60 min" },
          { title: "Duración", value: "3 meses" },
          { title: "Anestesia", value: "No aplica" },
        ],
      },
      {
        sectionTitle: "2. Hidratación + Masaje Kobido",
        cards: [
          {
            title: "Hidratación Facial (Láminas de Oro) + Masaje Kobido (Rostro, Cuello y Escote)",
            value: " costo de acuerdo a valoración medica",
          },
          { title: "Duración", value: "90 min" },
          { title: "Duración", value: "3 meses" },
          { title: "Anestesia", value: "No aplica" },
        ],
      },
      {
        sectionTitle: "3. Hidratación Inyectable",
        cards: [
          { title: "Hidratación Facial Inyectable", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "9 - 12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "1• ✓ Fotoprotección SPF 50+ mineral desde el día siguiente.\n2• ✓  Limpieza con espumas sin sulfatos por 72 horas.\n3• ✓ Evitar maquillaje oil-free × 12 horas (optimiza sellado de activos)."
        },
        {
          numero: "2",
          titulo:"¿Por qué elegir este ritual?",
          texto: "<li>Sin downtime: Retoma actividades sociales inmediatamente.</li>\n<li>Resultados acumulativos: Mejora progresiva de la densidad dérmica.</li>\n<li>Efecto glow: Luminosidad duradera hasta 4 semanas.</li>"
        },
         
      ],
      videoUrl: imagen19
    }
  },
  "hiperhidrosis": {
    id: "hiperhidrosis",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Control de Hiperhidrosis con Toxina Botulínica: Solución Definitiva contra la Sudoración Excesiva",
    titulo1: "Protocolo clínico para regular la actividad de glándulas sudoríparas en axilas o manos, mejorando la calidad de vida del paciente.",
    pregunta: "¿Cómo actúa la toxina botulínica?",
    descripcion: `<ul><strong2>✓ Bloqueo neuromotor:</strong2> Inhibe la liberación de acetilcolina, neurotransmisor que activa las glándulas sudoríparas.\n
<strong2>✓ Efecto localizado:</strong2> Reduce hasta el 90% de la sudoración en la zona tratada.\n
<strong2>✓ Duración:</strong2> Resultados mantenidos por 6-9 meses (varía según metabolismo).

<strong>Beneficios Clave</strong>
<strong2>▪</strong2> Alivio inmediato de humedad y molestias en manos/axilas.
<strong2>▪</strong2> Procedimiento ambulatorio en 20 minutos.
<strong2>▪</strong2> Sin cicatrices ni recuperación prolongada.
<strong2>▪</strong2> Compatible con actividades diarias desde el primer día.

<strong>Protocolo de Aplicación</strong>
<strong2>Evaluación previa:</strong2> Test de Minor (yodo-almidón) para delimitar área afectada.

<strong2>Técnica:</strong2> Microinyecciones superficiales con aguja de 30G.

<strong2>Dosis:</strong2> Personalizada según severidad (ej: 50-100 U en axilas).</ul>`,
    imagenHero: imagen19,
    imagen1: imagen20,
    imagen2: imagen21,
    infoCards: [
      {
        sectionTitle: "1. Tratamiento de Hiperhidrosis",
        cards: [
          { title: "Axilar o palmar", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "9 - 12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓ Primeras 4 horas:</strong> <li>Mantener posición erguida.</li><li>Evitar manipular la zona.</li>"
        },
        {
          numero: "2",
          titulo:"✓ Primeras 24 horas:",
          texto: "<li>Suspender ejercicio intenso, saunas y piscinas.</li><li>Aplicar compresas frías si hay inflamación.</li>"
        },
        {
          numero: "3",
          titulo:"✓ Efectos temporales:",
          texto: "<li>Leves hematomas (resuelven en 48-72 h).</li><li>Sensación de tirantez (dura menos de 5 días).</li>"
        },
        {
          numero: "4",
          titulo:"¿Quiénes son candidatos?",
          texto: "<li>Pacientes con hiperhidrosis primaria refractaria a antitranspirantes.</li><li>No aplicable en embarazo, miastenia gravis o infecciones locales.</li>"
        },
      ],
      videoUrl: imagen22
    }
  },
  "hydrafacial®": {
    id: "hydrafacial®",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Hydrafacial®: Hidrodermoabrasión para una Piel Radiante",
    titulo1: "Tecnología patentada que unifica limpieza profunda, exfoliación y bioestimulación en un solo tratamiento sin downtime.",
    pregunta: "¿Cómo funciona?",
    descripcion: `<ul><strong>El sistema Hydrafacial® utiliza tecnología Vortex-Fusion® en 4 pasos:</strong>x

<strong2>Desincrustación:</strong2> Succión con espiral que elimina células muertas, comedones y residuos de contaminación.

<strong2>Exfoliación química:</strong2> Ácido glicólico/salicílico para regular pH y poros.

<strong2>Infusión de cócteles:</strong2> Serums personalizados con péptidos, antioxidantes (como resveratrol) y ácido hialurónico.

<strong2>Protección LED:</strong2> Luz roja/azul para sellar resultados y reducir bacterias.

<strong>Beneficios Clínicos</strong>
✓ Elimina microplásticos y metales pesados acumulados (efecto detox).
✓ Reduce poros abiertos y estrés oxidativo en un 75%.
✓ Aumenta la hidratación epidérmica en un 90% (medido por corneometría).
✓ Ideal preeventos: Resultados glow en 45 minutos.

<strong>Protocolo Personalizado</strong>
<strong2>Evaluación previa:</strong2> Análisis cutáneo para seleccionar sueros (hidratación, antiedad, despigmentante).

<strong2>Duración:</strong2> 30-60 minutos.

<strong2>Frecuencia:</strong2> Mensual para mantenimiento óptimo.

<strong>Recomendaciones Previas</strong>
✓ Evitar láseres ablativos, microneedling o peelings profundos × 15 días.
✓ Suspender retinoides orales/tópicos × 72 horas.</ul>`,
    imagenHero: imagen22,
    imagen1: imagen23,
    imagen2: imagen24,
    infoCards: [
      {
        sectionTitle: "1. Tratamiento Hydrafacial",
        cards: [
          { title: "Procedimiento", value: " costo de acuerdo a valoración medica " },
          { title: "Aplicación", value: "60 min" },
          { title: "Duración", value: "1 - 4 meses" },
          { title: "Anestesia", value: "No aplica" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Aplicar SPF 50+ mineral diariamente (evita hiperpigmentación).\n<strong>✓</strong> Usar limpiadores sin fragancia × 48 horas.\n<strong>✓</strong> Postergar depilación con cera × 5 días."
        },
        {
          numero: "2",
          titulo:"Contraindicaciones",
          texto: "▪ Alergia a mariscos (por contenido de quitina en algunos sueros).\n▪ Embarazo/lactancia (por precaución).\n▪ Heridas abiertas o dermatitis activa en zona."
        },
      ],
      videoUrl: imagen25
    }
  },
  "limpieza": {
    id: "limpieza",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Limpieza Facial Profesional: Detox y Renovación Epidérmica",
    titulo1: "Protocolo dermatológico para eliminar impurezas, restaurar el equilibrio cutáneo y potenciar la luminosidad natural.",
    pregunta: "Proceso de Limpieza en 5 Fases",
    descripcion: `<ul><strong>1. Fase 1: Desincrustación Manual</strong>
✓ Exfoliación enzimática para remoción de células queratinizadas.
✓ Preparación de poros sin fricción agresiva.

<strong> 2.Fase 2: Terapia de Vapor Ozono</strong>
✓ Apertura poral controlada + oxigenación profunda.
✓ Extracción manual de comedones (puntos negros/miliares).

<strong> 3. Fase 3: Fototerapia LED</strong>
✓ Luz azul (415 nm): Elimina C. acnes en pieles grasas.
✓ Luz roja (633 nm): Calma irritación postextracción.

<strong> 4.Fase 4: Mascarilla Hidroplástica</strong>
✓ Tecnología criogénica para reducir edema/eritema.
✓ Sellado de activos hidratantes (ácido hialurónico crosslinked).

<strong>5. Fase 5: Blindaje Solar</strong>
✓ Aplicación de SPF 50+ con textura fluid para piel sensible.

<strong>Beneficios Clínicos</strong>
<strong2>✓</strong2> Reducción del 90% de microcomedones.
<strong2>✓</strong2> Disminución de poros dilatados en 28 días.
<strong2>✓</strong2> Regulación del manto hidrolipídico.
<strong2>✓</strong2> Prevención de brotes acneicos recurrentes.

<strong>Indicado para:</strong>
<strong2>▪</strong2> Pieles con signos de <strong2>"fatiga cutánea"</strong2>: opacidad, aspereza o descamación.
<strong2>▪</strong2> Secuelas de exposición a contaminantes/UV.
<strong2>▪</strong2> Preparación pre-peelings o láseres.</ul>`,
    imagenHero: imagen25,
    imagen1: imagen26,
    imagen2: imagen27,
    infoCards: [
      {
        sectionTitle: "1. Limpieza Facial",
        cards: [
          { title: "Limpieza facial", value: "costo de acuerdo a valoración medica" },
          { title: "Procedimiento", value: "60 min" },
          { title: "Duración", value: "Variable" },
          { title: "Anestesia", value: "No aplica" },
        ],
      },
      {
        sectionTitle: "2. Limpieza Corporal",
        cards: [
          { title: "Limpieza espalda, glúteos o pecho", value: " costo de acuerdo a valoración medica " },
          { title: "Procedimiento", value: "60 min" },
          { title: "Duración", value: "Variable" },
          { title: "Anestesia", value: "No aplica" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Fotoprotección solar rigurosa × 7 días.\n<strong>✓</strong>  Limpieza con productos suaves y sin alcohol.\n<strong>✓</strong>  Evitar maquillaje oil-free × 12 horas."
        },
        {
          numero: "2",
          titulo:"Factores que Dañan tu Piel",
          texto: "▪ Ambientales: Polución, radiación IR-A, metales pesados.\n▪ Hábitos: Fumar, dormir con maquillaje, limpieza agresiva.\n▪ Dieta: Exceso de azúcares refinados y grasas trans."
        },
      ],
      videoUrl: imagen28
    }
  },
  "labios": {
    id: "labios",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Labios Volumizados con Ácido Hialurónico: Armonía y Definición",
    titulo1: "Técnica no invasiva para realzar el contorno labial, corregir asimetrías y restaurar volumen perdido por edad o genética.",
    pregunta: "¿Cómo logra el ácido hialurónico definir y voluminizar los labios de forma natural?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>El ácido hialurónico reticulado actúa como:</strong2>
✓ Biorelleno estructural: Aporta volumen y soporte al vermellón.
✓ Hidratante profundo: Capta hasta 1,000 veces su peso en agua.
✓ Perfilador inteligente: Define el arco de Cupido y eleva comisuras caídas.

<strong>Beneficios Clave:</strong>
✓ Resultados naturales y adaptados a tu anatomía.
✓ Efecto inmediato (visible tras la aplicación).
✓ Duración de 6-12 meses (dependiendo del metabolismo).
✓ Reversible con hialuronidasa si es necesario.

<strong>Procedimiento:</strong>
<li><strong2>Diseño personalizado:</strong2> Marcado del arco labial y zonas a potenciar.</li>
<li><strong2>Técnica de inyección:</strong2> Microcánulas romas para minimizar hematomas.</li>
<li><strong2>Productos usados:</strong2> Ácido hialurónico cohesivo (20-25 mg/ml).</li>
<li><strong2>Duración:</strong2> 20-30 minutos.</li></ul>`,
    imagenHero: imagen28,
    imagen1: imagen29,
    imagen2: imagen30,
   infoCards: [
      {
        sectionTitle: "1. Perfilado de Labios",
        cards: [
          { title: "Procedimiento", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "12 - 18 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento ácido hialurónico",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong>  Evitar manipular/morder los labios × 48 h.\n<strong>✓</strong> Reposo físico × 24 h (gimnasio, saunas, solarium). Aplicar compresas frías si hay inflamación.n<strong>✓</strong>  Hidratación labial con productos sin alcohol."
        },
        
        {
          numero: "2",
          titulo:"Efectos Temporales",
          texto: "▪ Leves hematomas o edema (desaparecen en 2-5 días).\n▪ Tirantez inicial (mejora con masajes suaves indicados por el especialista)."
        },
        {
          numero: "3",
          titulo:"Contraindicaciones",
          texto: "▪ Herpes labial activo.\n▪ Alergias a anestésicos tópicos.\n▪ Embarazo/lactancia (precaución)."
        },
      ],
      videoUrl: imagen31,
    }
  },
  "mentón": {
    id: "mentón",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Mentón Definido con Ácido Hialurónico: Equilibrio Facial Sin Cirugía",
    titulo1: "Solución estética para corregir la retracción del mentón, mejorando la proporción facial y el perfil.",
    pregunta: "¿Cómo redefine el ácido hialurónico la línea del mentón?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>✓ Volumización estratégica:</strong2> Aporta estructura al hueso mentoniano para armonizar con el resto del rostro.
<strong2>✓ Soporte tridimensional:</strong2> Crea un efecto de proyección natural.
<strong2>✓ Integración tisular:</strong2> Se adapta a la anatomía sin migraciones.

<strong>Beneficios Clave:</strong>
<strong2>✓</strong2> Resultados visibles desde la primera sesión.
<strong2>✓</strong2> Duración de 12-18 meses (dependiendo del producto usado).
<strong2>✓</strong2> Ideal para equilibrar rostros con mandíbula corta o asimetrías.
<strong2>✓</strong2> Minimiza la apariencia de papada submental.

<strong>Procedimiento:</strong>
<li><strong2>Diseño personalizado:</strong2> Análisis de proporciones áureas faciales.</li>
<li><strong2>Técnica de aplicación:</strong2> Microinyecciones en planos profundos para mayor naturalidad.</li>
<li><strong2>Productos usados:</strong2> Ácido hialurónico de alta densidad (24-28 mg/ml).</li>
<li><strong2>Duración:</strong2> 20-30 minutos.</li></ul>`,
    imagenHero: imagen31,
    imagen1: imagen32,
    imagen2: imagen33,
    infoCards: [
      {
        sectionTitle: "1. Perfilado de Mentón",
        cards: [
          { title: "Procedimiento", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "18 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Mentón ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong>  Evitar ejercicio intenso/saunas × 24 h.\n<strong>✓</strong> Aplicar hielo intermitente si hay inflamación.\n<strong>✓</strong>  No masajear la zona × 7 días."
        },
        
        {
          numero: "2",
          titulo:"Efectos Temporales",
          texto: "▪  Leve edema o equimosis (resuelven en 3-5 días).\n▪ Sensación de tensión (dura 48 horas)."
        },
        {
          numero: "3",
          titulo:"Contraindicaciones",
          texto: "▪ Infecciones activas en la zona.\n▪ Alergias a componentes del producto.\n▪ Embarazo (por precaución)."
        },
      ],
      videoUrl: imagen34,
    }
  },
  "nanopore": {
    id: "nanopore",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Nanopore®: Terapia de Bioestimulación con Micropunciones",
    titulo1: "Técnica no invasiva que potencia la regeneración cutánea mediante microcanales controlados, ideal para corregir hiperpigmentación y textura irregular.",
    pregunta: "¿Cómo logra Nanopore® regenerar la piel y corregir imperfecciones?",
    descripcion: `<ul><strong>Mecanismo de Acción</strong>
<strong>✓ Micropunciones automatizadas:</strong> Crea canales de 0,1-0,3 mm de profundidad para infundir activos.
<strong>✓ Estimulación colágena:</strong> Reactiva fibroblastos, aumentando la síntesis de colágeno tipo III en un 40%.
<strong>✓ Penetración dirigida:</strong> Potencia la absorción de vitaminas C, ácido tranexámico y péptidos en capas específicas.

<strong>Beneficios Clínicos</strong>
<li>✓ Reducción de melasma y cloasma en 8-12 semanas.</li>
<li>✓ Minimización de poros dilatados (efecto visible en 3 sesiones).</li>
<li>✓ Hidratación epidérmica aumentada en un 70% (corneometría).</li>
<li>✓ Corrección de cicatrices atróficas por acné.</li>
<strong>Protocolo de Tratamiento</strong>

<strong>1. Evaluación dermatológica:</strong>

▪ Análisis de fototipo y mapeo de lesiones con luz UV.

▪ Determinación de cóctel de activos (personalizado por necesidad).

<strong>2. Aplicación:</strong>

▪Duración: 45 minutos por sesión.

▪Frecuencia: 3 sesiones mensuales + mantenimiento trimestral.

<strong>3. Tecnología:</strong>

▪Agujas de titanio quirúrgico estériles.

▪Profundidad ajustable (100-300 micras).</ul>`,
    imagenHero: imagen34,
    imagen1: imagen35,
    imagen2: imagen36,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Nanopore",
        cards: [
          { title: "Vitaminas", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "60 min" },
          { title: "Duración", value: "3 - 4 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
      {
        sectionTitle: "1. Tratamiento Nanopore",
        cards: [
          { title: "Tranexamico", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "60 min" },
          { title: "Duración", value: "3 - 4 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Nanopore ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Fotoprotección SPF 50+ cada 3 horas × 7 días.\n<strong>✓</strong> Limpieza con syndets sin fragancia × 72 h.\n<strong>✓</strong>   Evitar exfoliantes físicos/químicos × 5 días.\n<strong>✓</strong>Aplicar apósitos cicatriciales nocturnos (si hay descamación)."
        },
        
        {
          numero: "2",
          titulo:"Efectos Temporales",
          texto: "▪  Eritema leve (2-5 días).\n▪ Descamación fina (indica renovación celular)."
        },
        {
          numero: "3",
          titulo:"Recomendaciones Clave",
          texto: "<strong>✓</strong> Ideal pre-evento: Realizar última sesión 4 semanas antes.\n<strong>✓</strong> Combinar con peelings enzimáticos para potenciar resultados.\n<strong>✓</strong>   No aplicar durante brotes activos de rosácea o dermatitis."
        },
      ],
      videoUrl: imagen37,
    }
  },
  "ojeras": {
    id: "ojeras",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Corrección de Ojeras con Ácido Hialurónico: Mirada Revitalizada",
    titulo1: "Solución no quirúrgica para atenuar hundimientos, pigmentación y fatiga en el contorno ocular.",
    pregunta: "¿Cómo rejuvenece el ácido hialurónico el área periocular?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>✓ Relleno estructural:</strong2> Compensa la pérdida de grasa subtarsal que causa sombras oscuras.
<strong2>✓ Camuflaje óptico:</strong2> Neutraliza tonalidades azuladas/verdosas al mejorar el grosor dérmico.
<strong2>✓ Estimulación de colágeno:</strong2> Aumenta la densidad cutánea para reducir transparencia vascular.

<strong>Beneficios Clave</strong>
✓ Resultados naturales desde el primer día.

✓ Duración de 12-18 meses (dependiendo del metabolismo).

✓ Minimiza efecto de "ojeras hundidas" y bolsas pseudograsas.

✓ Compatible con maquillaje × 24 horas.

<strong>Procedimiento</strong>
<strong2>Diseño personalizado:</strong2>

Técnica de inyección en plano suborbicular (evita edema).

<strong2>Producto usado:</strong2> Ácido hialurónico cohesivo de baja densidad (15-18 mg/ml).

<strong2>Duración:</strong2> 20-30 minutos.

<strong2>Anestesia:</strong2> Crema anestésica tópica (sin agujas).</ul>`,
    imagenHero: imagen37,
    imagen1: imagen38,
    imagen2: imagen39,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Ojeras",
        cards: [
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },    
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Ojeras ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Mantener posición vertical × 4 h (previene migración).\n<strong>✓</strong>  Evitar ejercicio/saunas × 24 h.\n<strong>✓</strong>  Aplicar compresas frías si hay inflamación. \n<strong>✓</strong>  Hidratación con productos sin parabenos × 7 días."
        },
        
        {
          numero: "2",
          titulo:"Efectos Temporales",
          texto: "▪  Equimosis leves (desaparecen en 3-5 días).\n▪ Tirantez inicial (mejora con masajes linfáticos guiados)."
        },
        {
          numero: "3",
          titulo:"Recomendaciones Clave",
          texto: "<strong>✓</strong> Alergias a anestésicos locales.\n<strong>✓</strong> Edema palpebral crónico.\n<strong>✓</strong>   Blefaroplastia reciente (<6 meses)."
        },
      ],
      videoUrl: imagen40
    }
  },
  "peeling": {
    id: "peeling",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Peeling Químico Personalizado: Renovación Epidérmica Controlada",
    titulo1: "Protocolo dermatológico para corregir imperfecciones cutáneas mediante exfoliación química graduable (superficial, medio o profundo).",
    pregunta: "¿Cómo actúa el peeling químico para renovar la piel de forma segura?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>Los peelings actúan en 3 niveles:</strong2>
<strong2>✓ Exfoliación química:</strong2> Elimina queratinocitos dañados y activa turnover celular.
<strong2>✓ Estimulación dérmica:</strong2> Incrementa la síntesis de colágeno tipo I/III y ácido hialurónico.
<strong2>✓ Normalización pigmentaria:</strong2> Inhibe la tirosinasa para unificar el tono.

<strong>Beneficios Clínicos</strong>
✓ Corrección de hiperpigmentación (melasma, léntigos).

✓ Reducción de cicatrices acneicas atróficas.

✓ Textura alisada y poros minimizados.

✓ Efecto glow inmediato + rejuvenecimiento progresivo.

<strong>Protocolo MediDerma®</strong>
<strong2>Cócteles utilizados:</strong2>

<strong2>Ácido Retinoico (RU):</strong2> Renovación celular y antienvejecimiento.

<strong2>Ácido Mandélico (M):</strong2> Pieles sensibles/acnéicas.

<strong2>Ferulac®:</strong2> Antioxidante con vitamina E.

<strong2>Ácido Azelaico (AZ):</strong2> Antiinflamatorio y despigmentante.

<strong>Fases del tratamiento:</strong>

<strong>Diagnóstico dermatoscópico:</strong>
▪ Evaluación de fototipo y grosor epidérmico.
▪ Selección de concentración según necesidad .

<strong>Aplicación:</strong>
<strong2>▪ Duración:</strong2> 30-60 minutos/zona.
▪ Sin anestesia (sensación de calor controlado).

<strong>Resultados:</strong>
▪ Cambios visibles desde la 1ª sesión.
▪ Máximo efecto a los 30 días (ciclo completo de renovación).</ul>`,
    imagenHero: imagen40,
    imagen1: imagen41,
    imagen2: imagen42,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Nanopore",
        cards: [
          { title: "Aplicación", value: "60 min" },
          { title: "Duración", value: "Variable" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Peeling ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>1. ✓ Protección solar estricta:</strong> SPF 50+ físico × 8 días.\n<strong>✓ Evitar calor/fricción:</strong> Saunas, ejercicio intenso × 72 h.\n<strong>✓   Rutina post-peeling:</strong>\n<strong>▪ </strong> Limpieza suave sin sulfatos.\n<strong>▪ </strong>  Hidratación con ceramidas/ácido hialurónico.\n<strong>▪ </strong> Evitar retinoides/alfahidroxiácidos × 5 días."
        },
        
        {
          numero: "2",
          titulo:"Contraindicaciones Absolutas",
          texto: "▪  Embarazo/lactancia.\n▪ Uso reciente de isotretinoína oral (<6 meses).\n▪ Herpes activo o infecciones en zona a tratar.\n▪ Enfermedades autoinmunitarias activas (lupus, rosácea grave)."
        },
      ],
      videoUrl: imagen43,
    }
  },
  "pómulos": {
    id: "pomulos",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Pómulos Definitivos con Ácido Hialurónico: Elevación y Armonía Facial",
    titulo1: "Tratamiento no quirúrgico para realzar la estructura malar, mejorando la proporción facial y proyectando un aspecto rejuvenecido.",
    pregunta: "¿Cómo redefine el ácido hialurónico la estructura de los pómulos?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>✓ Volumización 3D:</strong2> Aporta soporte al hueso cigomático para destacar la línea de los pómulos.
<strong2>✓ Integración anatómica:</strong2> Se adapta a la curvatura ósea sin migraciones.
<strong2>✓ Bioestimulación:</strong2> Reactiva la producción de colágeno tipo I para firmeza duradera.

<strong>Beneficios Clave</strong>
✓ Resultados naturales desde la primera sesión.
✓ Duración de 12-18 meses (según metabolismo).
✓ Ideal para rostros con pérdida de volumen por envejecimiento o genética.
✓ Combate el efecto de "cara plana" y aporta luminosidad.

<strong>Procedimiento</strong>
<strong2>1. Diseño personalizado:</strong2>

▪Análisis de proporciones áureas para ubicación precisa.

▪Técnica de inyección en plano supraperióstico (naturalidad).

<strong2>Producto usado:</strong2> Ácido hialurónico de alta densidad (22-26 mg/ml).

<strong2>Duración:</strong2> 20-30 minutos.</ul>`,
    imagenHero: imagen43,
    imagen1: imagen44,
    imagen2: imagen45,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Pómulos",
        cards: [
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "18 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Pómulos ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Evitar ejercicio intenso/saunas × 24 h.\n<strong>✓</strong> No masajear la zona × 7 días (previene desplazamiento).\n<strong>✓</strong>   Aplicar compresas frías si hay inflamación."
        },
        
        {
          numero: "2",
          titulo:"Efectos Temporales",
          texto: "▪  Leve edema o equimosis (resuelven en 2-5 días).\n▪ Tirantez inicial (dura 24-48 horas)."
        },
        {
          numero: "3",
          titulo:"Contraindicaciones",
          texto: "<strong>•</strong> Infecciones activas en la zona (acné, herpes).\n<strong>•</strong> Alergias a componentes del producto.\n<strong>•</strong>   Embarazo/lactancia (precaución)."
        },
      ],
      videoUrl: imagen46,
    }
  },
  "plasma": {
    id: "plasma",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Plasma Facial con PRP: Bioestimulación Autóloga para Rejuvenecimiento Integral",
    titulo1: "Protocolo regenerativo que utiliza factores de crecimiento derivados de tu propia sangre para revitalizar la piel sin riesgo de rechazo.",
    pregunta: "¿Cómo activa el PRP la regeneración celular?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>

<strong2>1. Extracción sanguínea:</strong2> Toma de 15-20 ml de sangre venosa.

<strong2>2. Centrifugación especializada:</strong2> Aislamiento de plaquetas en concentración 4-6x mayor que la sangre basal.

<strong2>3. Activación de factores de crecimiento:</strong2> Liberación de PDGF, VEGF, TGF-β y EGF.

<strong2>4. Microinyecciones estratégicas:</strong2> Aplicación en dermis profunda y unión dermoepidérmica.

<strong>Beneficios Clínicos</strong>
<strong2>✓ Reestructuración dérmica:</strong2>
▪ +58% de colágeno tipo I (biopsias a 3 meses).
▪ Mejora de la elasticidad (Cutometer®).
<strong2>✓ Corrección de imperfecciones:</strong2>
▪️ Reducción de cicatrices atróficas en 83% de casos.
▪️ Atenuación de estrías blancas.
<strong>✓ Efecto glow inmediato:</strong>
▪ Luminosidad por microcirculación activada.
▪ Piel más compacta en 21 días.

<strong>Protocolo Avanzado</strong>
<strong2>Tecnología utilizada:</strong2>

• Tubos de gel de silicio para máxima pureza plaquetaria.

• Agujas de calibre 30G (indoloras) + técnica de mesoterapia fraccionada.

<strong2>Cronograma:</strong2>

<strong>1. Evaluación inicial:</strong>
✓ Análisis de calidad cutánea con sistema Antera 3D®.
✓ Determinación de zonas diana (rostro, cuello, escote).

<strong>2.Sesiones:</strong>
✓ 3-4 aplicaciones (intervalos de 4 semanas).
✓ Mantenimiento semestral..</ul>`,
    imagenHero: imagen46,
    imagen1: imagen47,
    imagen2: imagen48,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Plasma",
        cards: [
          { title: "Aplicación", value: "60 min" },
          { title: "Duración", value: "Variable" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Nanopore ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Evitar maquillaje × 12 h.\n<strong>✓</strong> Aplicar SPF 50+ mineral diariamente.\n<strong>✓</strong>   Hidratación con ácido hialurónico no reticulado.\n<strong>✓</strong>No exposición al calor extremo × 48 h."
        },
        
        {
          numero: "2",
          titulo:"Ventajas Clave vs. Otros Tratamientos",
          texto: "<strong2>▪  Seguridad absoluta:</strong2> Material autólogo = 0% alergias.\n<strong2>▪ Sin downtime:</strong2> Retorno inmediato a actividades.\n<strong2>▪ Efecto acumulativo:</strong2> Resultados mejoran con cada sesión."
        },
        {
          numero: "3",
          titulo:"Contraindicaciones",
          texto: "<strong>✓</strong> Trastornos de coagulación (hemofilia, trombocitopenia).\n<strong>✓</strong> Infecciones sistémicas activas.\n<strong>✓</strong>  Terapia anticoagulante reciente (<72 h)."
        },
      ],
      videoUrl: imagen49
    }
  },
  "acido-hialuronico": {
    id: "acido-hialuronico",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Ácido Hialurónico Ultrapuro para Bioremodelación Cutánea",
    titulo1: "Protocolo antiaging que combina ácido hialurónico de alto y bajo peso molecular en alta concentración (64 mg) para rejuvenecimiento facial, cervical y escote.",
    pregunta: "¿Cómo actúa este tratamiento?",
    descripcion: `<ul><strong>✓ Doble mecanismo molecular:</strong>
<strong2>▪️ HA de alto peso:</strong2> Brinda hidratación profunda y soporte estructural.
<strong2>▪️ HA de bajo peso:</strong2> Estimula fibroblastos para producir colágeno tipo I/III y elastina.
<strong2>✓ Técnica de aplicación:</strong2> Microinyecciones en puntos estratégicos (rostro, cuello, escote) para tensar piel laxa.

<strong>Beneficios Clínicos</strong>
✓ Reducción de flacidez en papada y mejillas.

✓ Disminución de arrugas finas (código de barras, patas de gallo).

✓ Piel más luminosa y uniforme en 4-6 semanas.

✓ Efecto lifting no quirúrgico con duración de 6-12 meses.

<strong>Protocolo de Tratamiento</strong>
<strong2>1. Evaluación inicial:</strong2>

Análisis de elasticidad cutánea con elastómetro.

<strong>2. Aplicación:</strong>

<strong2>•Sesión 1:</strong2> 5 puntos de inyección por hemirrostro.

<strong2>•Sesión 2:</strong2> Refuerzo a los 20-30 días (optimiza síntesis de colágeno).

<strong>3. Tecnología:</strong>

• HA estabilizado térmicamente para mayor durabilidad.</ul>`,
    imagenHero: imagen49,
    imagen1: imagen50,
    imagen2: imagen51,
  infoCards: [
      {
        sectionTitle: "1. Ácido Hialuronico",
        cards: [
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Ácido Hialuronico ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Evitar ejercicio intenso/saunas × 24 h.\n<strong>✓</strong> Aplicar compresas frías si hay inflamación.\n<strong>✓</strong>   Hidratación con productos no comedogénicos.\n<strong>✓</strong>Fotoprotección SPF 50+ diaria."
        },
        
        {
          numero: "2",
          titulo:"Efectos Temporales",
          texto: "▪  Leves hematomas o edema (desaparecen en 2-3 días).\n▪ Tirantez inicial (dura 24-48 horas)."
        },
        {
          numero: "3",
          titulo:"Contraindicaciones",
          texto: "<strong>✓</strong> Embarazo/lactancia.\n<strong>✓</strong> Alergias al ácido hialurónico o lidocaína.\n<strong>✓</strong>   Enfermedades autoinmunes activas."
        },
      ],
      videoUrl: imagen52
    }
  },
//   "rinomodelacion": {
//     id: "rinomodelacion",
//     doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
//     titulo: "Rinomodelación con Ácido Hialurónico: Redefinición Nasal Sin Cirugía",
//     titulo1: "Solución estética para corregir asimetrías, jorobas o ángulos nasales desarmónicos mediante bioestimulación con ácido hialurónico.",
//     pregunta: "¿Cómo moldea el ácido hialurónico la estructura nasal?",
//     descripcion: `<ul><strong>Mecanismo de Acción:</strong>
// <strong2>✓ Corrección volumétrica:</strong2> Rellena depresiones y suaviza irregularidades del dorso nasal.
// <strong2>✓ Definición angular:</strong2> Ajusta el ángulo nasolabial y la punta nasal para mayor armonía.
// <strong2>✓ Integración tisular:</strong2> Se adapta a la anatomía sin alterar la función respiratoria.

// <strong>Beneficios Clave:</strong>
// ✓ Resultados naturales visibles en 24-48 horas.
// ✓ Duración de 12-18 meses (dependiendo del producto usado).
// ✓ Procedimiento ambulatorio de 20-30 minutos.
// ✓ Ideal para pacientes que rechazan o posponen rinoplastia quirúrgica.

// <strong>Procedimiento</strong>
// <strong2>1. Diseño personalizado:</strong2>

// • Análisis fotográfico 3D para simulación digital del resultado.

// • Marcaje de puntos estratégicos (dorso, punta, columela).

// <strong>2. Técnica:</strong>

// •Microinyecciones con agujas ultrafinas (30G) o cánulas romas.

// •<strong2>Producto usado:</strong2> Ácido hialurónico cohesivo de alta densidad (24-28 mg/ml).</ul>`,
//     imagenHero: imagen52,
//     imagen1: imagen53,
//     imagen2: imagen54,
//   infoCards: [
//       {
//         sectionTitle: "1. Tratamiento Rinomodelación",
//         cards: [
//           { title: "Aplicación", value: "15 - 30 min" },
//           { title: "Duración", value: "12 meses" },
//           { title: "Anestesia", value: "Si" },
//         ],
//       },
//     ],
//     postOperatorio: {
//       titulo: "Cuidados Postratamiento Rinomodelación ",
//       descripcion: "",
//       pasos: [
//         {
//           numero: "1",
//           titulo:"Cuidados Postratamiento",
//           texto: "<strong>✓</strong> Evitar gafas o presión sobre la nariz × 72 h.\n<strong>✓</strong>  Reposo físico × 24 h (gimnasio, saunas, yoga invertido).\n<strong>✓</strong>   Aplicar hielo encapsulado si hay edema.\n<strong>✓</strong>Dormir boca arriba × 3 noches."
//         },
        
//         {
//           numero: "2",
//           titulo:"Efectos Temporales",
//           texto: "▪  Eritema/equimosis leve (resuelven en 3-7 días).\n▪ Sensación de tensión (dura 48 horas)."
//         },
//         {
//           numero: "3",
//           titulo:"Contraindicaciones",
//           texto: "<strong>✓</strong> Infecciones nasales activas (herpes, rinitis).\n<strong>✓</strong> Alteraciones de coagulación no controladas.\n<strong>✓</strong>   Antecedentes de necrosis vascular en zona nasal."
//         },
//       ],
//       videoUrl: imagen55,
//     }
//   },
  "surcos": {
    id: "surcos",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Corrección de Surcos Nasogenianos con Ácido Hialurónico: Recupera la Armonía Facial",
    titulo1: "Tratamiento no invasivo para atenuar pliegues profundos entre nariz y labios, restaurando volumen y juventud al rostro.",
    pregunta: "¿Cómo rellena el ácido hialurónico los surcos nasogenianos?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>✓ Volumización inteligente:</strong2> Compensa la pérdida de grasa subdérmica que genera hendiduras.
<strong2>✓ Estimulación dérmica:</strong2> Reactiva la síntesis de colágeno tipo I para firmeza duradera.
<strong2>✓ Integración tisular:</strong2> Se adapta a la dinámica muscular sin alterar expresiones faciales.

<strong>Beneficios Clave:</strong>
✓ Resultados naturales visibles in situ.

✓ Duración de 9-15 meses (según producto y metabolismo).

✓ Hidratación profunda + efecto tensor progresivo.

✓ Ideal para combinar con otros tratamientos de lifting no quirúrgico.

<strong>Procedimiento</strong>
<strong>1. Evaluación dinámica:</strong>

Análisis de movilidad facial en reposo y sonrisa.

<strong>2. Técnica de inyección:</strong>

Microcánulas romas para minimizar hematomas.

<strong2>Producto usado:</strong2> Ácido hialurónico cohesivo de media densidad (20-24 mg/ml).

<strong2>Duración:</strong2> 15-20 minutos.</ul>`,
    imagenHero: imagen55,
    imagen1: imagen56,
    imagen2: imagen57,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Surcos",
        cards: [
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Surcos ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓</strong> Mantener posición vertical × 4 h (previene migración).\n<strong>✓</strong> Evitar ejercicio/saunas × 24 h.\n<strong>✓</strong> Aplicar compresas frías si hay inflamación.\n<strong>✓</strong> Hidratar con productos no comedogénicos."
        },
        
        {
          numero: "2",
          titulo:"Efectos Temporales",
          texto: "▪ Eritema o equimosis leve (resuelven en 2-5 días).\n▪ Tirantez inicial (mejora con masajes linfáticos suaves)."
        },
        {
          numero: "3",
          titulo:"Recomendaciones Clave",
          texto: "<strong>✓</strong> Herpes labial activo en zona perioral.\n<strong>✓</strong> Alergias a anestésicos tópicos.\n<strong>✓</strong> Embarazo/lactancia (precaución)."
        },
      ],
      videoUrl: imagen58,
    }
  },
  "sustentación": {
    id: "sustentación",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Bioestimulación Facial con Ácido Hialurónico para Soporte Tisular",
    titulo1: "Técnica de rejuvenecimiento tridimensional para el tercio medio facial",
    pregunta: "¿Cómo funciona la bioestimulación facial?",
    descripcion: `<ul><strong>✓ Mecanismo de Acción:</strong>
Este protocolo estético emplea formulaciones de ácido hialurónico reticulado de alta densidad, aplicado estratégicamente en zonas clave del macizo óseo malar. Su acción dual ofrece:

• Soporte estructural: Recupera la proyección pómulo-malar

• Efecto tensor: Minimiza la pérdida de tonicidad cutánea

• Revitalización volumétrica: Contrarresta la reabsorción grasa asociada al envejecimiento

<strong>Protocolo de Tratamiento</strong>

<strong2>1.Evaluación previa:</strong2>

• Análisis fotográfico 3D para mapeo facial

• Test de movilidad tisular y elasticidad dérmica

• Contraindicado durante gestación/lactancia

<strong2>2. Aplicación:</strong2>

• Técnica de microcánulas romas (minimiza hematomas)

• Duración: 20-30 minutos

• Resultados visibles in situ

<strong>Ventajas Clínicas</strong>
✓ Corrección de la flacidez en surcos nasogenianos
✓ Perfilado natural del óvalo facial
✓ Estimulación colágena progresiva
✓ Efecto duradero (12-18 meses)

Cuidados Postaplicación
<strong2>Primeras 4 horas:</strong2>

• Mantener posición erguida

• Evitar manipulación de la zona tratada

<strong2>Primeras 72 horas:</strong2>

• Suspender actividades deportivas intensas
• 
Evitar exposición a altas temperaturas (saunas, vapor)

<strong2>Manejo de efectos transitorios:</strong2>

• Crioterapia localizada ante equimosis leves

• Hidratación reforzada con ácido hialurónico tópico</ul>`,
    imagenHero: imagen58,
    imagen1: imagen59,
    imagen2: imagen60,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Sustentación",
        cards: [
          { title: "Aplicación", value: "20-30 minutos (ambulatorio)." },
          { title: "Duración", value: "12 a 18 meses (dependiendo de metabolismo y cuidados postratamiento)." },
          { title: "Anestesia", value: "Topica" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Sustentación ",
      descripcion: "Los pacientes deben presentarse sin maquillaje el día del procedimiento y evitar consumo de anticoagulantes naturales (ajo, jengibre) 48 horas previas. Se recomienda sesión de evaluación personalizada para determinar densidad y cantidad de producto requerido según morfología facial.",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: " ✓ Estructura técnica mejorada\n✓ Terminología médica actualizada\n ✓ Flujo lógico de información\n✓ Especificación de mecanismos de acción \n✓Detalles procedimentales ampliados\n✓Formato profesional para comunicación clínica"
        },
      ],
      videoUrl: imagen61,
    }
  },
  "toxina-botulinica": {
    id: "toxina-botulinica",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Toxina Botulínica: Rejuvenecimiento Facial y Control de Hiperhidrosis",
    titulo1: "Solución no quirúrgica para atenuar arrugas dinámicas y regular la sudoración excesiva.",
    pregunta: "¿Cómo actúa la toxina botulínica?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>✓ Bloqueo neuromuscular:</strong2> Inhibe la liberación de acetilcolina, relajando músculos hiperactivos.
<strong2>✓ Prevención de arrugas:</strong2> Reduce la formación de líneas estáticas (surcos profundos).
<strong2>✓ Regulación glandular:</strong2> Disminuye la actividad de glándulas sudoríparas en zonas específicas.

<strong>✓ Aplicaciones Principales</strong>
<strong>1. Tercio Superior Facial:</strong>

• Líneas frontales, entrecejo ("11"), patas de gallo.

• Efecto lifting de cejas (técnica Brow Lift).

<strong>Hiperhidrosis:</strong>

• Axilas, palmas, plantas de pies.

• Reducción del 80-90% de sudoración (resultados en 72 h).

<strong>Cuello y Escote:</strong>

• Bandas platismales ("cuello de pavo").

• Suaviza arrugas verticales y horizontaliza el contorno.

<strong>✓ Protocolo de Tratamiento</strong>
<strong2>1. Evaluación dinámica:</strong2>

• Análisis de movilidad muscular en reposo y gestual.

<strong2>2. Técnica de aplicación:</strong2>

• Microinyecciones con agujas de 32G (ultrafinas).

• Dosis personalizada según sexo, masa muscular y objetivos.

<strong2>Duración:</strong2> 15-20 minutos (ambulatorio).

<strong>✓ Beneficios Clave</strong>
• Resultados en <strong2>3-7 días</strong2> (máximo efecto a las 2 semanas).

• Duración de <strong2>4-6 meses</strong2> (repetible sin resistencia).

• Procedimiento ambulatorio indoloro.

• Compatible con otros tratamientos (rellenos, láser).</ul>`,
    imagenHero: imagen61,
    imagen1: imagen62,
    imagen2: imagen63,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Toxina Botulinica",
        cards: [
          { title: "Aplicación", value: "15 - 30 min" },
          { title: "Duración", value: "9 - 12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Toxina Botulinica ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>1. Posición vertical:</strong>\n ✓ Evitar acostarse o masajear zona × 4 h.\n<strong>2. Reposo físico:</strong>\n ✓  No gym, saunas o yoga invertido × 24 h.\n<strong>3. Efectos temporales:</strong>\n ✓  Leve edema/equimosis (resuelven en 48 h)."
        },
        
        {
          numero: "2",
          titulo:"Contraindicaciones",
          texto: "▪ Miastenia gravis o enfermedades neuromusculares.\n▪ Embarazo/lactancia (precaución).\n▪ Infecciones activas en zona de aplicación."
        },
      ],
      videoUrl: imagen64,
    }
  },
  "radiofrecuencia": {
    id: "radiofrecuencia",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Radiofrecuencia: Rejuvenecimiento por Estimulación Térmica Controlada",
    titulo1: "La radiofrecuencia es una tecnología no quirúrgica que utiliza ondas electromagnéticas para generar calor profundo (40-45°C) en las capas dérmicas, activando la reparación natural de la piel. Ideal para tratar flacidez, arrugas y pérdida de densidad en rostro y cuerpo, con resultados desde la primera sesión.",
    pregunta: "¿En qué consiste el tratamiento con Radiofrecuencia?",
    descripcion: `<ul><strong>Aplicaciones Específicas</strong>
  <strong>1.Radiofrecuencia Facial</strong>

<strong2>•Lifting no invasivo:</strong2> redefine óvalo facial, mejora pómulos y mandíbula.

<strong2>•Reducción de arrugas:</strong2> patas de gallo, surcos nasogenianos y frente.

<strong2>•Efecto tensor inmediato:</strong2> contracción de fibras de colágeno existentes.

<strong>2.Radiofrecuencia Corporal</strong>

<strong2>•Flacidez en abdomen, brazos y muslos.</strong2>

<strong2>•Reducción de celulitis fibrosa</strong2> (combinada con otros tratamientos).

<strong2>•Estimulación de circulación</strong2> para piel de naranja.

<strong>3.Radiofrecuencia Capilar</strong> (Opcional, si deseas incluir esta variante)

<strong2>•Bioestimulación del folículo piloso:</strong2> aumenta flujo sanguíneo en cuero cabelludo.

<strong2>•Combate la alopecia:</strong2> activa folículos en fase de reposo.

<strong2>•Potencia otros tratamientos:</strong2> como mesoterapia capilar o plasma rico en plaquetas.

<strong>Protocolo del Tratamiento</strong>
<strong2>1.Diagnóstico:</strong2> Evaluación de la piel/cabello con equipos especializados.

<strong2>2.Sesión:</strong2>

<strong2>•Duración:</strong2> 30-60 minutos (dependiendo del área).

<strong2>•Técnica:</strong2> Aplicación de gel conductor + manipulación con cabezal emisor.

<strong2>•Sensación:</strong2> Calor tolerable (sin dolor).


 <h3>Ventajas Clave vs. Otros Tratamientos</h3>
  <table>
    <thead>
      <tr>
        <th>Beneficio</th>
        <th>Radiofrecuencia</th>
        <th>Otros Métodos</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong2>No invasivo</strong2></td>
        <td>✔️</td>
        <td>✖️ (Láser/HIFU requieren más recuperación)</td>
      </tr>
      <tr>
        <td><strong2>Sin tiempo de inactividad</strong2></td>
        <td>✔️ (Puedes volver a tus actividades)</td>
        <td>✖️</td>
      </tr>
      <tr>
        <td><strong2>Resultados acumulativos</strong2></td>
        <td>✔️ (Mejora continua)</td>
        <td>✖️ (Efecto limitado en algunos casos)</td>
      </tr>
      <tr>
        <td><strong2>Duración del procedimiento</strong2></td>
        <td>30-60 min</td>
        <td>1-2 horas (dependiendo del método)</td>
      </tr>
      <tr>
        <td><strong2>Efectos secundarios</strong2></td>
        <td>Leve enrojecimiento (desaparece en horas)</td>
        <td>Hinchazón/moretones (en métodos agresivos)</td>
      </tr>
    </tbody>
  </table>
  <strong>Preguntas Frecuentes</strong>
❓ <strong2>¿Duele?</strong2>
No. Solo se percibe calor controlado (como un masaje tibio).

❓ <strong2>¿Cuántas sesiones necesito?</strong2>

• Facial: 4-6 sesiones (1 cada 2 semanas).

• Corporal: 6-8 sesiones (1 por semana).

❓ <strong2>¿Los resultados son permanentes?</strong2>
Duran <strong2>6 meses a 2 años </strong2>(dependiendo de edad y cuidados). Se recomienda <strong2>1 sesión de mantenimiento cada 3 meses.</strong2></ul>`,
    imagenHero: imagen65,
    imagen1: imagen66,
    imagen2: imagen67,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Radiofrecuencia",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "30-45 Min" },
          { title: "Duración", value: "1 cada 2 semanas." },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Radiofrecuencia ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados posteriores:",
          texto: "<strong>✓</strong> Usar protector solar diariamente.\n<strong>✓</strong> Evitar calor extremo (saunas, sol) por 48h.\n<strong>✓</strong> Mantener la piel hidratada.\n<strong>✓</strong> Beber abundante agua. \n<strong>✓</strong> Sesiones de mantenimiento cada 2-3 meses."
        },
        {
          numero: "2",
          titulo:"¿Para quién es ideal?",
          texto: "Personas con:\n• Flacidez leve a moderada en rostro o cuerpo.\n• Pérdida de definición en el óvalo facial.\n• Piel desvitalizada o con falta de firmeza.\n• Cicatrices deprimidas o estrías.\n<strong>Sesiones recomendadas:</strong> 4-6 sesiones (1 cada 2-4 semanas).\n<strong>Duración del resultado:</strong> 6-12 meses (dependiendo del cuidado)."
        },
              
      ],
      videoUrl: imagen68,
    }
  },
//   "radiofrecuencia-fraccionada-con-microagujas": {
//     id: "radiofrecuencia-fraccionada-con-microagujas",
//     doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
//     titulo: "Radiofrecuencia Fraccionada con Microagujas: Combina lo mejor de dos tecnologías para un rejuvenecimiento profundo",
//     titulo1: "La radiofrecuencia fraccionada con microagujas es un tratamiento mínimamente invasivo que estimula la producción de colágeno mediante calor controlado + microcanales en la piel. Ideal para tratar arrugas profundas, cicatrices de acné, estrías y poros dilatados con resultados visibles desde la primera sesión.",
//     pregunta: "<strong>¿Cómo funciona el tratamiento microagujas?</strong>",
//     descripcion: `<ul><strong2>1. Microagujas:</strong2> Crean canales microscópicos (0.5-2mm de profundidad)

// <strong2>2. Radiofrecuencia:</strong2> Se aplica energía térmica a través de los microcanales

// <strong2>3. Efecto dual:</strong2>

// <strong2>• Reparación inmediata:</strong2> Contracción de fibras de colágeno

// <strong2>• Regeneración a largo plazo:</strong2> Nuevas fibras de colágeno y elastina

// <strong>Beneficios Clave</strong>
// ✔️ <strong2>Reducción de arrugas profundas</strong2> (surcos nasogenianos, frente)
// ✔️ <strong2>Mejora hasta 80% cicatrices</strong2> de acné quirúrgicas o post-traumáticas
// ✔️ <strong2>Disminución de poros</strong2> y unificación de la textura
// ✔️ <strong2>Tratamiento de estrías</strong2> blancas y rojas
// ✔️ <strong2>Efecto lifting</strong2> sin cirugía.
//  <h3>Protocolo del Tratamiento</h3>
//   <table>
//     <thead>
//       <tr>
//         <th>Paso</th>
//         <th>Detalle</th>
//         <th>Duración</th>
//       </tr>
//     </thead>
//     <tbody>
//       <tr>
//         <td><strong2>1. Limpieza</strong2></td>
//         <td>Desmaquillado y antisepsia profesional</td>
//         <td>10 min</td>
//       </tr>
//       <tr>
//         <td><strong2>2. Anestesia</strong2></td>
//         <td>Aplicación de crema anestésica</td>
//         <td>30 min (acción)</td>
//       </tr>
//       <tr>
//         <td><strong2>3. Aplicación</strong2></td>
//         <td>Radiofrecuencia + microagujas (por áreas)</td>
//         <td>15-20 min</td>
//       </tr>
//       <tr>
//         <td><strong2>4. Post-tratamiento</strong2></td>
//         <td>Máscara calmante + protección solar</td>
//         <td>10 min</td>
//       </tr>
//       <tr class="total-row">
//         <td colspan="2"><strong2>TOTAL POR SESIÓN</strong2></td>
//         <td><strong>60-90 min</strong></td>
//       </tr>
//     </tbody>
//   </table>
//  <strong2> Duración total:</strong2> 60-90 min
// <strong2>Sesiones recomendadas:</strong2> 3-5 (cada 4-6 semanas)
//  <h3>Comparativa de Tecnologías</h3>
//   <table>
//     <thead>
//       <tr>
//         <th>Característica</th>
//         <th>RF + Microagujas</th>
//         <th>Láser CO2</th>
//         <th>RF Tradicional</th>
//       </tr>
//     </thead>
//     <tbody>
//       <tr>
//         <td><strong2>Penetración</strong2></td>
//         <td>Dermis media-profunda</td>
//         <td>Epidermis-dermis</td>
//         <td>Dermis superficial</td>
//       </tr>
//       <tr>
//         <td><strong2>Recuperación</strong2></td>
//         <td>2-3 días</td>
//         <td>7-10 días</td>
//         <td>Sin recuperación</td>
//       </tr>
//       <tr>
//         <td><strong2>Efecto en cicatrices</strong2></td>
//         <td>⭐⭐⭐⭐⭐</td>
//         <td>⭐⭐⭐⭐</td>
//         <td>⭐⭐</td>
//       </tr>
//       <tr>
//         <td><strong2>Dolor</strong2></td>
//         <td>Leve</td>
//         <td>Moderado</td>
//         <td >Mínimo</td>
//       </tr>
//       <tr>
//         <td><strong2>Sesiones necesarias</strong2></td>
//         <td>3-5</td>
//         <td>1-3</td>
//         <td>6-8</td>
//       </tr>
//     </tbody>
//   </table>
//   <strong>Preguntas Frecuentes</strong>
//  <strong>¿Es doloroso?</strong>

// • Solo se percibe leve incomodidad (gracias a la anestesia tópica).

//  <strong>¿Cuándo se ven resultados?</strong>

// • Inmediatos: Efecto tensor a las 72h.

// • Progresivos: Máximo resultado a los 3 meses.

//  <strong>¿Quién NO es candidato?</strong>

// • Embarazadas.

// •Pacientes con herpes activo.

// • Pieles con infecciones bacterianas.
// </ul>`,
//     imagenHero: imagen69,
//     imagen1: imagen69,
//     imagen2: imagen70,
//   infoCards: [
//       {
//         sectionTitle: "1. Tratamiento microagujas",
//         cards: [
//           { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
//           { title: "Aplicación", value: "15-20 Min" },
//           { title: "Duración", value: "12-18 Meses" },
//         ],
//       },
//     ],
//     postOperatorio: {
//       titulo: "Cuidados Postratamiento Microagujas ",
//       descripcion: "",
//       pasos: [
//         {
//           numero: "1",
//           titulo:"✓ Cuidados Postratamiento",
//           texto: "<strong>1. Primeras 24 horas:</strong>\n ✓ Evitar maquillaje.\n ✓ Usar serum regenerador<strong>2. Primera semana:</strong>\n✓ Protección solar SPF 50+\n✓ No rascar costritas (si aparecen)."
//         },
//         {
//           numero: "2",
//           titulo:"Mantenimiento:",
//           texto: "•1 sesión anual después del ciclo inicial."
//         },
              
//       ],
//       videoUrl: imagen71
//     }
//   },
  "fototerapia": {
    id: "fototerapia",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Fototerapia Dermatológica: Tratamiento con Luz Controlada para Rejuvenecimiento y Salud Cutánea",
    titulo1: "La fototerapia utiliza longitudes de onda específicas (LED o láser) para tratar múltiples condiciones de la piel sin dañar su superficie. Es ideal para acné, psoriasis, envejecimiento cutáneo y despigmentación, con resultados científicamente comprobados.",
    pregunta: "¿Cómo funciona la Fototerapia?",
    descripcion: `<ul><strong> 1.Luz Azul (415 nm):</strong>

• Elimina bacterias causantes del acné (P. acnes)

• Reduce inflamación en brotes activos

<strong>2. Luz Roja (633 nm):</strong>

• Estimula producción de colágeno y elastina

• Disminuye arrugas finas y mejora la elasticidad

<strong>3. Luz Amarilla (590 nm):</strong>

• Calma pieles con rosácea o sensibilidad extrema

• Unifica tono de piel

<strong>4. Infrarrojo (850 nm):</strong>

• Penetra profundamente para tratar flacidez

• Mejora la microcirculación.

  <table>
    <thead>
      <tr>
        <th>Tipo</th>
        <th>Longitud de Onda</th>
        <th>Indicaciones</th>
        <th>Duración</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong2>Luz Azul</strong2></td>
        <td>415 nm</td>
        <td>Acné activo (elimina bacterias)</td>
        <td>15-20 min</td>
      </tr>
      <tr>
        <td><strong2>Luz Roja</strong2></td>
        <td>633 nm</td>
        <td>Regeneración celular + arrugas</td>
        <td>20-30 min</td>
      </tr>
      <tr>
        <td><strong2>Luz Amarilla</strong2></td>
        <td>590 nm</td>
        <td>Rosácea + hiperpigmentación</td>
        <td>15 min</td>
      </tr>
      <tr>
        <td><strong2>Infrarrojo</strong2></td>
        <td>850 nm</td>
        <td>Flacidez + estimulación colágeno</td>
        <td>25 min</td>
      </tr>
    </tbody>
  </table>
  Total por sesión: 30-45 minutos
Sesiones recomendadas: 6-8 (1-2 por semana)
<table>
    <tr>
      <th>Criterio</th>
      <th>Fototerapia</th>
      <th>Láser CO2</th>
      <th>Peelings Químicos</th>
    </tr>
    <tr>
      <td><strong2>Dolor</strong2></td>
      <td class="best">Cero</td>
      <td>Moderado</td>
      <td>Leve</td>
    </tr>
    <tr>
      <td><strong2>Sesiones</strong2></td>
      <td>6-8</td>
      <td>1-3</td>
      <td>4-6</td>
    </tr>
    <tr>
      <td><strong2>Downtime</strong2></td>
      <td class="best">Ninguno</td>
      <td>7-10 días</td>
      <td>2-3 días</td>
    </tr>
  </table>
 <strong> Beneficios Clave</strong>
✔️ Sin tiempo de recuperación (puedes maquillarte inmediatamente)
✔️ Cero dolor (solo se percibe calor leve)
✔️ Combinable con otros tratamientos faciales
✔️ Resultados acumulativos que mejoran progresivamente
✔️ Efecto bactericida (ideal para pieles acneicas)

<strong>Preguntas Frecuentes</strong>
¿Quién es candidato ideal?
Personas con: acné leve a moderado, rosácea, signos tempranos de envejecimiento o hiperpigmentación.

¿Cuándo se ven resultados?

Acné: Mejoría en 2-4 semanas

Arrugas: Resultados visibles a las 6 semanas

¿Existen contraindicaciones?
No recomendado para: embarazadas, pacientes con lupus o fotosensibilidad medicamentosa.
</ul>`,
    imagenHero: imagen72,
    imagen1: imagen73,
    imagen2: imagen74,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Fototerapia",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "30-45 minutos (dependiendo del área tratada)" },
          { title: "Duración", value: "4-6 meses" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Fototerapia ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "<strong>1. Primeras 24 horas:</strong>\n ✓ Evitar productos con alcohol\n ✓ No usar exfoliantes físicos/químicos.<strong>2. Primera semana:</strong>\n✓ Aplicar SPF 50+ incluso en interiores\n✓ Hidratar 2 veces al día"
        },
        {
          numero: "2",
          titulo:"Mantenimiento:",
          texto: "• 1 sesión mensual después del ciclo inicial."
        },
              
      ],
      videoUrl: imagen75
    }
  },
  "enzimas-2-generación": {
    id: "enzimas-2-generación",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "PBSerum®: Terapia Enzimática de Segunda Generación",
    titulo1: "Protocolo avanzado para remodelación corporal y tratamiento de tejidos fibróticos mediante enzimas bioactivas.",
    pregunta: "¿Cómo actúan las enzimas PBSerum®?",
    descripcion: `<ul><strong>Mecanismo Triple de Acción:</strong>
<strong2>✓ Lipólisis enzimática:</strong2> Degrada adipocitos en áreas localizadas (abdomen, papada, flancos).
<strong2>✓ Reestructuración dérmica:</strong2> Estimula colágeno tipo III para mejorar la elasticidad cutánea.
<strong2>✓ Modulación fibrótica:</strong2> Reduce queloides y cicatrices hipertróficas mediante regulación de TGF-β.

<strong>✓ Beneficios Clave</strong>
• Reducción de grasa rebelde en 2-4 semanas.

• Mejora de flacidez en rostro y cuerpo (efecto lifting progresivo).

• Corrección de fibrosis postquirúrgicas o traumáticas.

• Procedimiento ambulatorio sin cicatrices.

<strong>Protocolo Clínico</strong>
<strong2>1. Evaluación inicial:</strong2>

• Diagnóstico con ecografía subcutánea para mapear áreas diana.

<strong2>2. Aplicación:</strong2>

• Microinyecciones indoloras con anestesia tópica.

<strong2>Duración:</strong2> 20 minutos/sesión.

<strong>3. Cronograma:</strong>

• 1-3 sesiones (intervalos de 30 días).

• Resultados máximos a los <strong2>3 meses</strong2>.</ul>`,
    imagenHero: imagen76,
    imagen1: imagen76,
    imagen2: imagen77,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Enzimas generacion 2",
        cards: [
          { title: "Aplicación", value: "20 min" },
          { title: "Resultados visibles", value: "De 15 a 30 días" },
          { title: "Anestesia", value: "Tópica" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Enzimas generacion 2 ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>1. Reposo físico::</strong>\n ✓ Evitar ejercicio intenso, saunas o piscinas × 24 h.\n<strong>2. Nutrición controlada:</strong>\n ✓   Dieta baja en grasas saturadas y azúcares × 15 días.\n<strong>3. Hidratación:</strong>\n ✓  Beber 2L de agua/día para potenciar detoxificación."
        },
        
        {
          numero: "2",
          titulo:"Contraindicaciones",
          texto: "▪ Embarazo o lactancia.\n▪ Enfermedades hepáticas o renales activas.\n▪ Alergias a componentes del cóctel enzimático."
        },
        {
          numero: "3",
          titulo:"Ventajas vs. Otros Tratamientos",
          texto: "<strong>✓Precisión:</strong> Actúa solo en células diana (sin dañar tejido circundante).\n<strong>✓Versatilidad:</strong>Combina con radiofrecuencia para resultados sinérgicos.\n<strong>✓Sin downtime:</strong> Retorno inmediato a actividades cotidianas."
        },
        
      ],
      videoUrl: imagen78
    }
  },
  "sueroterapia": {
    id: "sueroterapia",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Sueroterapia: Terapia Regenerativa con Medicamentos Biológicos",
    titulo1: "Protocolo basado en la administración de cócteles bioreguladores (Heel®) para restablecer el equilibrio fisiológico, potenciar la salud y mejorar la calidad de vida.",
    pregunta: "¿Qué es la Sueroterapia?",
    descripcion: `<ul>Técnica médica que utiliza inyectables de origen natural (plantas, minerales, vitaminas) para:
<strong2>✓ Desintoxicar</strong2> el organismo.
<strong2>✓ Estimular</strong2> funciones corporales debilitadas.
<strong2>✓ Prevenir</strong2> enfermedades crónicas.
<strong2>✓ Mejorar</strong2> el rendimiento físico y mental.

<strong>2. Mecanismo de Acción<strong>
<strong2>• Fase 1 (Evaluación):</strong2> Diagnóstico personalizado para identificar carencias o disfunciones.

<strong2>• Fase 2 (Aplicación):</strong2> Inyección intravenosa/intramuscular de cócteles Heel®.

<strong2>• Fase 3 (Resultados):</strong2>
<strong2>▪️ Primera semana:</strong2> Mejora energética y reducción de inflamación.
<strong2>▪️ 1 mes:</strong2> Regulación metabólica y cutánea visible.
<strong2>▪️ 3 meses:</strong2> Efecto acumulativo en sistema inmune y hormonal.

<strong>3. Beneficios Globales</strong>
• ✔️ Desintoxicación profunda (metales pesados, químicos).

• ✔️ Refuerzo inmunológico (+30% linfocitos T).

• ✔️ Rejuvenecimiento celular (estimulación de colágeno/elastina).

• ✔️ Equilibrio hormonal (menopausia, tiroides).

• ✔️ Recuperación post-enfermedad (COVID-19, infecciones virales).

<strong>4. Protocolos de Tratamiento</strong2>
<strong2>A. Evaluación Inicial (Sin Costo):<strong2>

• Historia clínica detallada.

• Análisis de necesidades individuales.

<strong>B. Cócteles Disponibles:</strong>

 <table>
        <thead>
            <tr>
                <th>N°</th>
                <th>Nombre</th>
                <th>Objetivo</th>
                <th>Indicaciones Clave</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <td>Detox Heel</td>
                <td>Eliminar toxinas acumuladas.</td>
                <td>Exposición a contaminantes, apoyo hepático.</td>
            </tr>
            <tr>
                <td>2</td>
                <td>Inmuno Heel</td>
                <td>Fortalecer defensas.</td>
                <td>Infecciones recurrentes, defensas bajas.</td>
            </tr>
            <tr>
                <td>3</td>
                <td>Metabol Heel</td>
                <td>Regular metabolismo.</td>
                <td>Obesidad, hígado graso, resistencia insulina.</td>
            </tr>
            <tr>
                <td>4</td>
                <td>Osteo Forte Heel</td>
                <td>Regenerar huesos/articulaciones.</td>
                <td>Artrosis, fracturas, tendinitis.</td>
            </tr>
            <tr>
                <td>5</td>
                <td>Hormo Heel</td>
                <td>Balancear hormonas.</td>
                <td>Menopausia, desequilibrios tiroideos.</td>
            </tr>
            <tr>
                <td>6</td>
                <td>Dermo Heel</td>
                <td>Revitalizar piel.</td>
                <td>Acné, rosácea, envejecimiento cutáneo.</td>
            </tr>
            <tr>
                <td>7</td>
                <td>Atletas Heel</td>
                <td>Optimizar rendimiento físico.</td>
                <td>Deportistas, prevención de lesiones.</td>
            </tr>
            <tr>
                <td>8</td>
                <td>Vital Heel</td>
                <td>Combatir fatiga crónica.</td>
                <td>Estrés, agotamiento mental.</td>
            </tr>
            <tr>
                <td>9</td>
                <td>Gastro Heel</td>
                <td>Reparar sistema digestivo.</td>
                <td>Colon irritable, gastritis.</td>
            </tr>
            <tr>
                <td>10</td>
                <td>Post Infección Heel</td>
                <td>Recuperar secuelas post-virales.</td>
                <td>COVID prolongado, herpes.</td>
            </tr>
            <tr>
                <td>11</td>
                <td>Vitamina C Endovenosa</td>
                <td>Antioxidación y luminosidad cutánea.</td>
                <td>Piel opaca, inmunodeficiencia.</td>
            </tr>
        </tbody>
    </table>
</ul>`,
    imagenHero: imagen79,
    imagen1: imagen79,
    imagen2: imagen80,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Sueroterapia",
        cards: [
          { title: "sesión de sueroterapia", value: "costo de acuerdo a valoración medica" },
          { title: "Resultados visibles", value: "De 15 a 30 días" },
          { title: "Anestesia", value: "No aplica" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Sueroterapia ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:" Recomendaciones y Contraindicaciones",
          texto: "<strong>✓ Previo al tratamiento:</strong>\n • Ayuno de 2 horas.\n• No consumir alcohol 24 h antes."
        },
        
        {
          numero: "2",
          titulo:"Post-tratamiento:",
          texto: "▪ Hidratación abundante.\n▪ Evitar ejercicio intenso × 12 h."
        },
        {
          numero: "3",
          titulo:"✖ Contraindicaciones:",
          texto: "▪ Embarazo/lactancia.\n▪ Alergias a componentes.\n▪ Enfermedades autoinmunes activas."
        },
        
      ],
      videoUrl: imagen81
    }
  },
  "tensamax": {
    id: "tensamax",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Tensamax® - Tensado Facial No Invasivo",
    titulo1: "Tratamiento de ultima generación para lifting facial sin cirugía.",
    pregunta: "Aplicación y Duración del Tratamiento",
    descripcion: `<ul>  📝 <strong>Protocolo de Aplicación</strong>
<strong>1. Evaluación inicial (20 min)</strong>

• Análisis facial digital para determinar áreas de flacidez.

• Medición de la elasticidad cutánea.

<strong>2. Preparación (15 min)</strong>

• Limpieza profunda con solución especial.

• Aplicación de gel conductor.

<strong>3. Sesión activa (30-40 min)</strong>

• Uso del cabezal de radiofrecuencia bipolar

<strong2>• Aplicación en 3 fases:</strong2>
<strong2>▪ Calentamiento</strong2> (10 min)
<strong2>▪ Estimulación</strong2> (15 min)
<strong2>▪ Sellado</strong2> (5 min)

<strong>4. Finalización </strong> (10 min)

• Aplicación de máscara fría calmante.

• Hidratación con ácido hialurónico.

⏳ <strong>Duración Total por Sesión</strong>
🔹 <strong2>75-90 minutos</strong2> (incluye preparación y post-tratamiento).
 <table>
    <thead>
      <tr>
        <th>Fase</th>
        <th>Procedimiento</th>
        <th>Duración</th>
        <th>Tecnología</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1. Preparación</td>
        <td>Limpieza + aplicación gel conductor</td>
        <td>15 min</td>
        <td>Soluciones dérmicas pH balanceado</td>
      </tr>
      <tr>
        <td>2. Calentamiento</td>
        <td>Radiofrecuencia bipolar (40-42°C)</td>
        <td>10 min</td>
        <td>Cabezal RF 3D</td>
      </tr>
      <tr>
        <td>3. Estimulación</td>
        <td>Activación de fibroblastos</td>
        <td>15 min</td>
        <td>Pulsos electromagnéticos</td>
      </tr>
      <tr>
        <td>4. Sellado</td>
        <td>Infusión de ácido hialurónico</td>
        <td>5 min</td>
        <td>Nanotecnología</td>
      </tr>
      <tr class="total-row">
        <td colspan="2">TOTAL POR SESIÓN</td>
        <td colspan="2">75-90 min</td>
      </tr>
    </tbody>
  </table>

📅 Frecuencia Recomendada
 <table>
    <thead>
      <tr>
        <th>Grado de Flacidez</th>
        <th>Edad Objetivo</th>
        <th>Sesiones</th>
        <th>Frecuencia</th>
        <th>Duración Ciclo</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Leve</td>
        <td>30-40 años</td>
        <td>3-4</td>
        <td>Semanal</td>
        <td>1 mes</td>
      </tr>
      <tr>
        <td>Moderada</td>
        <td>40-50 años</td>
        <td>5-6</td>
        <td>Cada 5 días</td>
        <td>5-6 semanas</td>
      </tr>
      <tr>
        <td>Avanzada</td>
        <td>+50 años</td>
        <td>6-8</td>
        <td>Bisemanal</td>
        <td>2-3 meses</td>
      </tr>
      <tr class="maintenance-row">
        <td colspan="2">Mantenimiento</td>
        <td>1</td>
        <td>Trimestral</td>
        <td>Continuo</td>
      </tr>
    </tbody>
  </table>

  ✨ <strong>Resultados Esperados</strong>
<strong2>• Efecto inmediato:</strong2> 30% de mejoría en firmeza (visible al terminar la sesión)

<strong2>• Máximo resultado:</strong2> A las 4 semanas (80-90% de mejoría)

<strong2>• Duración:</strong2> 6-12 meses (dependiendo de cuidados).

   <h3>Comparativa de Tecnologías de Tensado Facial</h3>
  <table>
    <thead>
      <tr>
        <th>Característica</th>
        <th>Tensamax®</th>
        <th>Hilos Tensores</th>
        <th>Ultherapy®</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Tipo de procedimiento</td>
        <td>No invasivo</td>
        <td>Mínimamente invasivo</td>
        <td>No invasivo</td>
      </tr>
      <tr>
        <td>Duración sesión</td>
        <td class="highlight">75-90 min</td>
        <td>45 min</td>
        <td>60 min</td>
      </tr>
      <tr>
        <td>Tiempo recuperación</td>
        <td class="best-option">0 horas</td>
        <td>3-5 días</td>
        <td>24 horas</td>
      </tr>
      <tr>
        <td>Anestesia requerida</td>
        <td class="best-option">No</td>
        <td>Local</td>
        <td>No</td>
      </tr>
      <tr>
        <td>Duración resultados</td>
        <td>6-12 meses</td>
        <td>1-2 años</td>
        <td>1 año</td>
      </tr>
    </tbody>
  </table>
</ul>`,
    imagenHero: imagen82,
    imagen1: imagen82,
    imagen2: imagen83,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Tensamax",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "85 minutos (1 hora 25 min)(Incluye evaluación, preparación, aplicación y cuidados post-tratamiento)" },
          { title: "Duración", value: " 6-12 meses (con mantenimiento trimestral)" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento tensamax ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "<strong>1. Primeras 24 horas:</strong>\n ✓ Evitar maquillaje.\n ✓ No exposición solar directa.<strong>\n2. Primera semana:</strong>\n✓ Usar SPF 50+ incluso en interiores\n✓ Aplicar crema tensor nocturna"
        },
        {
          numero: "2",
          titulo:"Mantenimiento:",
          texto: "• 1 sesión cada 3-4 meses.\n • Uso de productos con péptidos. "
        },
              
      ],
      videoUrl: imagen84
    }
  },
  "emsculpt": {
    id: "emsculpt",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Emsculpt® - Moldeamiento Corporal con Tecnología EMS",
    titulo1: "El único tratamiento no invasivo que construye músculo y quema grasa simultáneamente.",
    pregunta: "Aplicación y Duración del Tratamiento",
    descripcion: `<ul><strong>1. Estimulación electromagnética:</strong>

• Induce <strong2>20,000 contracciones musculares</strong2> por sesión (equivalente a 6 meses de gym intenso).

<strong>2. Doble acción:</strong>

<strong2>• Quema grasa:</strong2> Rompe adipocitos en áreas tratadas.

<strong2>• Construye músculo:</strong2> Hipertrofia fibras musculares.

<strong>3. Áreas tratables:</strong>

• Abdomen ("six pack").

• Glúteos (levantamiento y volumen).

• Brazos y muslos  . 
<h3>Protocolo por Sesión - Emsculpt®</h3>
  <table>
    <thead>
      <tr>
        <th>Paso</th>
        <th>Duración</th>
        <th>Detalle</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>1. Evaluación</strong></td>
        <td>15 min</td>
        <td>Análisis de composición corporal</td>
      </tr>
      <tr>
        <td><strong>2. Preparación</strong></td>
        <td>10 min</td>
        <td>Colocación de electrodos</td>
      </tr>
      <tr>
        <td><strong>3. Aplicación</strong></td>
        <td>30 min</td>
        <td>Pulsos HIFEM® (20,000 contracciones)</td>
      </tr>
      <tr>
        <td><strong>4. Finalización</strong></td>
        <td>5 min</td>
        <td>Hidratación y recomendaciones</td>
      </tr>
      <tr class="total-row">
        <td><strong2>TOTAL</strong2></td>
        <td><strong2>60 min</strong2></td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <h3>Plan de Sesiones Recomendado</h3>
  <table>
    <thead>
      <tr>
        <th>Objetivo</th>
        <th>Sesiones</th>
        <th>Frecuencia</th>
        <th>Duración Total</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Definición muscular</td>
        <td>4</td>
        <td>2 por semana</td>
        <td>2 semanas</td>
      </tr>
      <tr>
        <td>Volumen glúteo</td>
        <td>6</td>
        <td>Cada 3-4 días</td>
        <td>3 semanas</td>
      </tr>
      <tr class="highlight-row">
        <td>Mantenimiento</td>
        <td>1</td>
        <td>Mensual/Trimestral</td>
        <td>Continuo</td>
      </tr>
    </tbody>
  </table>
  <strong>⚡ Tecnología HIFEM®</strong>
<strong2>• 20,000 contracciones </strong2> por sesión (equivalente a 6 meses de gym)

<strong2>• +16% de masa muscular</strong2> en estudios clínicos

<strong2>• +19% reducción de grasa</strong2> en área tratada

 <h3>Comparativa de Tecnologías</h3>
  <table>
    <thead>
      <tr>
        <th>Característica</th>
        <th>Emsculpt®</th>
        <th>Criolipólisis</th>
        <th>Radiofrecuencia</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Aumento muscular</td>
        <td class="best">⭐⭐⭐⭐⭐</td>
        <td>⭐</td>
        <td>⭐⭐</td>
      </tr>
      <tr>
        <td>Reducción de grasa</td>
        <td>⭐⭐⭐⭐</td>
        <td class="best">⭐⭐⭐⭐⭐</td>
        <td>⭐⭐⭐</td>
      </tr>
      <tr>
        <td>Sesiones necesarias</td>
        <td>4-6</td>
        <td>1-2</td>
        <td>6-8</td>
      </tr>
      <tr>
        <td>Tiempo recuperación</td>
        <td class="best">0 horas</td>
        <td>3 días</td>
        <td class="best">0 horas</td>
      </tr>
    </tbody>
  </table>
  ⚠️<strong> Contraindicaciones</strong>
<strong2>•</strong2> Marcapasos o dispositivos electrónicos implantados

<strong2>•</strong2> Hernias abdominales

<strong2>•</strong2>Embarazo

<strong2>•</strong2> Implantes metálicos en área de tratamiento
</ul>`,
    imagenHero: imagen85,
    imagen1: imagen85,
    imagen2: imagen86,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Emsculpt",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "45 minutos (incluye preparación)." },
          { title: "Duración", value: " 6 meses a 1 año (dependiendo de hábitos como ejercicio y alimentación)." },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Emsculpt ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "<strong>1. Primeras 48 horas:</strong>\n ✓ Beber 2L de agua para eliminar toxinas.\n ✓ Evitar alcohol."
        },
        {
          numero: "2",
          titulo:"Primera semana:",
          texto: "• Consumir proteína extra (1.5g por kg de peso).\n • Caminar 30 min/día. "
        },
        {
          numero: "3",
          titulo:"Mantenimiento:",
          texto: "• 1 sesión de refuerzo cada 3 meses. "
        },
              
      ],
      videoUrl: imagen87
    }
  },
  "radiofrecuencia-fraccionada-con-microagujas-corporal": {
    id: "radiofrecuencia-fraccionada-con-microagujas-corporal",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Radiofrecuencia Fraccionada con Microagujas Corporal",
    titulo1: "La radiofrecuencia fraccionada con microagujas es un tratamiento innovador que combina dos tecnologías para mejorar la firmeza, reducir la flacidez y estimular la producción de colágeno. Ideal para remodelar el contorno corporal, tratar celulitis y atenuar estrías, con resultados progresivos y naturales.",
    pregunta: "¿En qué consiste el tratamiento?",
    descripcion: `<ul>El procedimiento utiliza microagujas que penetran la piel de forma controlada, creando microcanales. Al retirarse, se aplica radiofrecuencia directamente en las capas profundas de la piel, generando calor que estimula la regeneración celular y la contracción de fibras de colágeno. Es un método mínimamente invasivo, sin necesidad de cirugía.

<strong>Recomendaciones previas:</strong>

<strong2>•</strong2> Evitar exposición solar intensa 7 días antes.

<strong2>•</strong2> No aplicar cremas irritantes o con ácidos en la zona 48 horas previas.

<strong2>•</strong2> Contraindicado para embarazadas, personas con marcapasos o infecciones activas en la piel.

<strong>Beneficios destacados:</strong>

<strong2>•</strong2> Reducción de flacidez en abdomen, brazos y muslos.

<strong2>•</strong2> Mejora visible de la celulitis (grados I-III).

<strong2>•</strong2> Atenuación de estrías antiguas y cicatrices.

<strong2>•</strong2> Estimulación de colágeno para una piel más firme.

<strong2>•</strong2> Sin tiempo de reposo: retorno inmediato a actividades diarias.

<strong>Resultados esperados:</strong>

<strong2>• Inmediatos:</strong2> Piel más tensa y tonificada tras la sesión.

<strong2>• A corto plazo (2-4 semanas):</strong2> Mejora en la textura y reducción de hoyuelos por celulitis.

<strong2>• A largo plazo (3-6 meses):</strong2> Mayor densidad de colágeno y efecto lifting progresivo.
</ul>`,
    imagenHero: imagen88,
    imagen1: imagen88,
    imagen2: imagen89,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Radiofrecuencia fraccionada microagujas corporal",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "Entre 30 y 60 minutos, dependiendo del área corporal tratada (ejemplo: abdomen, muslos o brazos)." },
          { title: "Duración", value: " hasta 12-18 meses, con sesiones de mantenimiento anuales." },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Radiofrecuencia fraccionada microagujas corporal ",
      descripcion: "El procedimiento puede causar leve enrojecimiento o sensibilidad, que desaparece en 24-48 horas.01. Aplicar cremas hidratantes y protector solar SPF50+.",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "✓ Aplicar cremas hidratantes y protector solar SPF50+.\n✓  Evitar ejercicio intenso, saunas o piscinas durante 48 horas.Beber 2L de agua para eliminar toxinas.\n✓ No frotar la zona tratada ni usar exfoliantes por 3 días. \n✓ Contraindicado en pieles con heridas abiertas o alergias activas."
        },
              
      ],
      videoUrl: imagen90
    }
  },
  "masajes-reductores-y-moldeamiento": {
    id: "masajes-reductores-y-moldeamiento",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Masajes reductores y de moldeamiento corporal",
    titulo1: "Los masajes reductores y de moldeamiento son técnicas manuales que combinan movimientos específicos para activar la circulación, eliminar toxinas, reducir la acumulación de grasa localizada y mejorar la apariencia de la piel. Ideales para complementar tratamientos estéticos y potenciar resultados en áreas como abdomen, caderas, glúteos y muslos.",
    pregunta: "¿En qué consiste el tratamiento?",
    descripcion: `<ul><strong>Técnicas utilizadas:</strong>

<strong2>• Amasamiento profundo:</strong2> Movimientos intensos para romper cúmulos de grasa y estimular el drenaje linfático.

<strong2>• Presiones circulares: </strong2>Activan la microcirculación y ayudan a reducir la retención de líquidos.

<strong2>• Rodillos o ventosas:</strong2> En algunos casos, se usan herramientas para potenciar el efecto reductor y combatir la celulitis.

<strong>Productos aplicados:</strong> Cremas o aceites termogénicos (con cafeína, mentol o retinol) para acelerar el metabolismo local.

<strong>Recomendaciones previas:</strong>
<strong2>•</strong2> Evitar comer 2 horas antes del masaje.

<strong2>•</strong2> Beber agua para facilitar la eliminación de toxinas.

<strong2>•</strong2> Contraindicado en casos de heridas abiertas, varices severas o embarazo.

<strong>Beneficios destacados:</strong>
<strong2>•</strong2> Reducción de medidas en zonas localizadas.

<strong2>•</strong2> Mejora de la circulación sanguínea y linfática.

<strong2>•</strong2> Atenuación de la piel de naranja (celulitis).

<strong2>•</strong2> Piel más suave y tonificada.

<strong2>•</strong2> Efecto relajante y desinflamante.

<strong>Duración de la aplicación (por sesión):</strong>
<strong2>• Tiempo estimado:</strong2> 45-60 minutos por sesión.

<strong2>• Frecuencia recomendada:</strong2> 2-3 sesiones semanales durante 4-8 semanas, según los objetivos.

<strong>Resultados esperados:</strong>
<strong2>• Inmediatos:</strong2> Sensación de ligereza y piel más suave.

<strong2>• A corto plazo (2-4 semanas):</strong2> Reducción de hinchazón y mejora en la textura de la piel.

<strong2>• A largo plazo (6-8 semanas):</strong2> Disminución visible de grasa localizada y celulitis.

<strong>Duración de los efectos:</strong>
Los resultados se mantienen siempre que se combine con:
🔹 <strong2>Alimentación balanceada y ejercicio regular.</strong2>
🔹 <strong2>Hidratación adecuada.</strong2>
🔹 Sesiones de mantenimiento mensuales.

</ul>`,
    imagenHero: imagen91,
    imagen1: imagen91,
    imagen2: imagen92,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Masajes reductores y moldeamiento",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "45 a 60 minutos por área tratada (ejemplo: abdomen, glúteos o muslos)." },
          { title: "Duración", value: " 4-6 meses con sesiones de refuerzo 1 vez cada 15 días tras finalizar el plan inicial" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Masajes reductores y moldeamiento ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: " ✓ Beber 2 litros de agua al día para eliminar toxinas.\n ✓ Evitar alimentos altos en sodio o grasas saturadas.\n ✓Usar fajas o prendas compresivas si lo recomienda el especialista.\n ✓No exponer la zona a calor extremo (saunas) en las primeras 12 horas."
        },
              
      ],
      videoUrl: imagen93
    }
  },
  "tratamiento-para-celulitis": {
    id: "tratamiento-para-celulitis",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Tratamiento Integral para Celulitis",
    titulo1: "Este procedimiento combina tecnologías avanzadas y técnicas personalizadas para reducir la (piel de naranja), mejorar la textura cutánea y restaurar la firmeza en áreas como muslos, glúteos y abdomen. Ideal para quienes buscan resultados visibles sin cirugía.",
    pregunta: "¿En qué consiste el tratamiento?",
    descripcion: `<ul> El protocolo integra <strong2>radiofrecuencia,  vacumterapia, sculpt y drenaje linfático</strong2>, actuando en tres niveles:

<strong2>1. Romper nódulos fibrosos</strong2> mediante energía térmica y mecánica.

<strong2>2. Estimular la circulación</strong2> para eliminar toxinas y líquidos retenidos.

<strong2>3. Reactivar la producción de colágeno</strong2> para una piel más lisa y tonificada.

<strong>Recomendaciones previas:</strong>

<strong2>•</strong2> Evitar el consumo de alcohol y tabaco 48 horas antes.

<strong2>•</strong2> Hidratar la piel diariamente 1 semana antes del tratamiento.

<strong2>•</strong2> Contraindicado en embarazo, heridas abiertas o uso de anticoagulantes.

<strong>Beneficios destacados:</strong>

<strong2>•</strong2> Reducción de hoyuelos y fibrosis en zonas afectadas.

<strong2>•</strong2> Piel más uniforme, suave y libre de irregularidades.

<strong2>•</strong2> Mejora de la circulación sanguínea y linfática.

<strong2>•</strong2> Sin incisiones ni tiempo de reposo prolongado.

<strong2>•</strong2> Resultados progresivos y naturales.

<strong>Resultados esperados:</strong>

<strong2>• Inmediatos:</strong2> Piel más tersa y menor sensación de pesadez.

<strong2>• A corto plazo (4-6 semanas):</strong2> Reducción visible de la celulitis (hasta 40-60%).

<strong2>• A largo plazo (3 meses):</strong2> Remodelación del tejido y efecto lifting duradero.
</ul>`,
    imagenHero: imagen94,
    imagen1: imagen94,
    imagen2: imagen95,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento para celulitis",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "60-90 minutos (según técnicas combinadas)." },
          { title: "Duración", value: " 6-12 meses (con hábitos saludables y sesiones de refuerzo)." },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento para celulitis ",
      descripcion: "El procedimiento puede causar leve enrojecimiento o sensibilidad, que desaparece en 24-48 horas.",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "✓ Aplicar cremas con cafeína o centella asiática para potenciar el efecto.\n ✓ Beber 2 litros de agua al día para eliminar toxinas.\n ✓Evitar ropa ajustada y exposición solar directa sin SPF50+ durante 1 semana.\n ✓Combinar con ejercicio regular y dieta baja en sodio para mantener resultados."
        },

              
      ],
      videoUrl: imagen96
    }
  },
  "maderoterapia": {
    id: "maderoterapia",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Maderoterapia Corporal",
    titulo1: "La maderoterapia es una técnica ancestral que utiliza herramientas de madera (como rodillos, paletas y esferas) para realizar masajes profundos que activan la circulación, reducen la celulitis y moldean la silueta. Ideal para combatir la grasa localizada y mejorar la textura de la piel de forma natural y no invasiva.",
    pregunta: "¿En qué consiste el tratamiento?",
    descripcion: `<ul>El procedimiento emplea instrumentos de madera (como <strong2>rodillos de jade, gua sha o paletas</strong2>), diseñados para adaptarse a las curvas del cuerpo. Mediante movimientos específicos de amasado, presión y arrastre, se estimula el sistema linfático, se rompen cúmulos de grasa y se reactiva la producción de colágeno.

<strong> Recomendaciones previas:</strong>

<strong2>•</strong2> Evitar comidas pesadas 2 horas antes de la sesión.

<strong2>•</strong2> Hidratar la piel con cremas o aceites ligeros previo al masaje.

<strong2>•</strong2> Contraindicado en embarazo, varices severas o pieles con heridas o irritaciones.

<strong>Beneficios destacados:</strong>

<strong2>•</strong2> Reducción de la “piel de naranja” (celulitis grados I-II).

<strong2>•</strong2> Disminución de medidas en abdomen, caderas y muslos.

<strong2>•</strong2> Mejora de la circulación sanguínea y eliminación de toxinas.

<strong2>•</strong2> Piel más tonificada y libre de flacidez.

<strong2>•</strong2> Efecto relajante y desinflamante inmediato.

<strong>Resultados esperados:</strong>

<strong2>• Inmediatos:</strong2> Piel más suave y menor sensación de hinchazón.

<strong2>• A corto plazo (4-6 semanas):</strong2> Reducción de 1-3 cm en zonas tratadas y menor apariencia de celulitis.

<strong2>• A largo plazo (3 meses):</strong2> Silueta más definida con mantenimiento continuo.
</ul>`,
    imagenHero: imagen97,
    imagen1: imagen97,
    imagen2: imagen98,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Maderoterapia",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "60 minutos para tratamiento completo (abdomen, caderas, muslos y brazos)." },
          { title: "Duración", value: " 2-4 meses, dependiendo de hábitos de vida." },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Maderoterapia ",
      descripcion: "El procedimiento puede causar leve enrojecimiento o sensibilidad, que desaparece en 24 horas.",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "✓  Beber abundante agua para facilitar la eliminación de toxinas.\n ✓ Evitar exposición solar directa sin protección SPF50+ durante 24 horas.\n ✓Realizar ejercicio moderado (caminar, yoga) para potenciar el drenaje.\n ✓Usar fajas moldeadoras por 2-4 horas post-tratamiento si se recomienda."
        },
             
      ],
      videoUrl: imagen99
    }
  },
  "masaje-relajante": {
    id: "masaje-relajante",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Masaje Relajante",
    titulo1: "El masaje relajante es una terapia manual diseñada para aliviar tensiones musculares, reducir el estrés y promover un estado de bienestar integral. Ideal para personas con rutinas exigentes, dolores posturales o simplemente para reconectar con el equilibrio físico y mental.",
    pregunta: "¿En qué consiste el tratamiento?",
    descripcion: `<ul>El terapeuta utiliza técnicas suaves de amasado, fricción y presión en músculos y tejidos blandos, combinadas con aceites esenciales (lavanda, manzanilla o eucalipto) para potenciar la relajación. Se enfoca en zonas como espalda, cuello, hombros y piernas.

<strong2>Recomendaciones previas:</strong2>

<strong2>•</strong2> Evitar comer en exceso 1-2 horas antes del masaje.

<strong2>•</strong2> Comunicar al terapeuta alergias a aceites o condiciones médicas (ej.: lesiones recientes).

<strong2>•</strong2> Contraindicado en casos de fiebre, heridas abiertas o flebitis.

<strong>Beneficios destacados:</strong>

<strong2>•</strong2> Alivio de contracturas y rigidez muscular.

<strong2>•</strong2> Reducción de ansiedad y mejora del sueño.

<strong2>•</strong2> Estimulación de la circulación sanguínea y linfática.

<strong2>•</strong2> Liberación de endorfinas para una sensación de bienestar.

<strong2>•</strong2> Sin efectos secundarios ni tiempo de recuperación.

<strong>Resultados esperados:</strong>

<strong2>• Inmediatos:</strong2> Relajación profunda y disminución de la tensión.

<strong2>• A corto plazo (24-48 horas):</strong2> Mejor movilidad y reducción de dolores posturales.

<strong2>• A largo plazo (sesiones continuas):</strong2> Prevención de estrés crónico y mejora de la calidad de vida.
</ul>`,
    imagenHero: imagen100,
    imagen1: imagen100,
    imagen2: imagen101,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Masaje relajante",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "90 minutos para tratamientos completos (incluyendo pies, manos y cuero cabelludo)." },
          { title: "Duración", value: " 3-7 días (dependiendo del estilo de vida y nivel de estrés del paciente)." },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Masaje relajante ",
      descripcion: "El masaje puede generar somnolencia o leve sensibilidad en zonas muy tensionadas.",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "✓  Beber agua tibia con limón para eliminar toxinas.\n ✓ Evitar actividades físicas intensas o duchas calientes en las siguientes 2 horas.\n ✓Reposar 15-20 minutos post-sesión para potenciar el efecto relajante.\n ✓No aplicar cremas con alcohol en la piel tras el masaje."
        },
             
      ],
      videoUrl: imagen102
    }
  },
  "exosomas-capílar": {
    id: "exosomas-capílar",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Terapia Regenerativa con Exosomas Vegetales",
    titulo1: "Protocolo de vanguardia para revitalizar piel y cuero cabelludo mediante nanotecnología basada en vesículas bioactivas.",
    pregunta: "¿Cómo funcionan los exosomas?",
    descripcion: `<ul><strong>Mecanismo de Acción:</strong>
<strong2>✓ Comunicación intercelular:</strong2> Liberan proteínas, ARN y lípidos que activan la autoreparación tisular.
<strong2>✓ Modulación inflamatoria:</strong2> Inhiben citocinas proinflamatorias (IL-6, TNF-α).
<strong2>✓ Bioestimulación:</strong2> Incrementan la síntesis de colágeno/queratina en un 40%.

<strong>Protocolos de Aplicación</strong>
<strong>1. Tratamiento Dérmico</strong>
<strong2>• Dosis:</strong2> 5.000 millones de exosomas liofilizados + cóctel de nutrientes (vitaminas A/C, péptidos, glutatión).

<strong2>• Beneficios:</strong2>
✓ Hidratación profunda (aumento del 70% en retención hídrica).
✓ Reducción de hiperpigmentación postinflamatoria.
✓ Disminución de poros dilatados y textura irregular.
✓ Efecto antiedad (mejora de elasticidad en 6 semanas).

<strong>2. Tratamiento Capilar</strong>
<strong2>Dosis:</strong2> 10.000 millones de exosomas + factores de crecimiento epidérmico.

<strong2>Beneficios:</strong2>
✓ Reactivación de folículos en fase telógena (90% de éxito en alopecia androgenética).
✓ Aumento de densidad capilar (+30% en 3 meses).
✓ Protección contra miniaturización folicular por DHT.

<strong>3. Proceso del Tratamiento</strong>
<strong2>1.Evaluación inicial:</strong2>

• Diagnóstico con dermatoscopia digital o tricoscopia.

<strong2>2. Técnicas de aplicación:</strong2>

<strong2>• Piel:</strong2> Láser Fotona (bioestimulación) o radiofrecuencia Morpheus8.

<strong2>. Cuero cabelludo:</strong2> Microinyecciones con dispositivo Fixer®.

<strong2>Duración:</strong2> 45-90 minutos (según zona).</ul>`,
    imagenHero: imagen103,
    imagen1: imagen103,
    imagen2: imagen104,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Exosomas",
        cards: [
          { title: "Exosomas", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "Variable segun canal" },
          { title: "Duración", value: "Variable" },
          { title: "Anestesia", value: "Dependiendo el canal de aplicación" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Exosomas ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"Cuidados Postratamiento",
          texto: "<strong>✓Primeras 24 horas:</strong>\n • No lavar rostro/cuero cabelludo.\n •  Evitar cosméticos con alcohol o fragancias.\n<strong>✓ Primera semana:</strong>\n  • Fotoprotección SPF 50+ en zonas expuestas.\n  • Limpieza suave con productos pH balanceado."
        },
        
        {
          numero: "2",
          titulo:"Beneficios Adicionales",
          texto: "▪ <strong2>Sin downtime:</strong2> Actividades normales inmediatas.\n▪ <strong2>Resultados progresivos:</strong2> Máximo efecto a los 2-3 meses.\n▪ <strong2>Seguridad:</strong2> Componentes 100% vegetales y no transgénicos."
        },
        {
          numero: "3",
          titulo:"Contraindicaciones",
          texto: "• ✖ Embarazo o lactancia.\n• ✖ Enfermedades autoinmunes activas (lupus, psoriasis grave).\n• ✖ Alergias a componentes del cóctel (raro <0.1%)."
        },
        
      ],
      videoUrl: imagen105
    }
  },
  
  "mesocapilar": {
    id: "mesocapilar",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Mesocapilar: Bioestimulación Capilar para Recuperar la Densidad del Cabello",
    titulo1: "Protocolo avanzado contra la alopecia, diseñado para fortalecer folículos pilosos y reactivar el crecimiento capilar.",
    pregunta: "¿Cómo funciona el tratamiento mesocapilar?",
    descripcion: `<ul><strong>✓ Mecanismo de Acción</strong>
<strong2>• Infusión de nutrientes:</strong2> Microinyecciones de vitaminas (Biotina, B12), péptidos y factores de crecimiento (FGF, VEGF).

<strong2>• Estimulación folicular:</strong2> Aumenta la vascularización del cuero cabelludo y prolonga la fase anágena.

<strong2>• Bloqueo de DHT (solo Dutasteride):</strong2> Inhibe la 5-alfa-reductasa para prevenir la miniaturización folicular.

<strong>✓ Beneficios Clínicos</strong>
<strong2>• +45% de densidad capilar</strong2> en 4-6 meses (estudios clínicos).

<strong2>• Reducción de caída</strong2> en un 70% desde la 3ª sesión.

<strong2>• Cuero cabelludo revitalizado:</strong2> Menos grasa, picor o descamación.

<strong2>Resultados naturales</strong2> sin efectos sistémicos.

<strong>Protocolos Disponibles</strong>
<strong2>1. Mesocapilar General</strong2>
<strong2>Para:</strong2> Alopecia incipiente o mantenimiento preventivo.

<strong2>Aplicación:</strong2>
✓ Sesiones mensuales (mínimo 4).
✓ Sin consulta previa obligatoria (se recomienda seguimiento).
✓ Incluye shampoo/ampollas domiciliarias con <strong2>cafeína y zinc.</strong2>

<strong2>2. Mesocapilar Dutasteride</trong>
<strong2>• Para:</strong2> Alopecia androgenética avanzada (Hamilton-Norwood III+).

<strong2>• Aplicación:</strong2>
✓ Microcanalización con Dermapen + dutasterida tópica.
✓ Requiere <strong2>diagnóstico dermatológico previo</strong2> (tricoscopia).
✓ Protocolo de 6-8 sesiones + mantenimiento trimestral.

<strong>Procedimiento Paso a Paso</strong>
<strong>1. Limpieza:</strong> Desinfección del cuero cabelludo con solución antiséptica.

<strong2>2. Aplicación:</strong2>

<strong2>• Técnica:</strong2> Agujas de 0.5-1 mm de profundidad (indoloro).

<strong2>• Duración:</strong2> 20-30 minutos.

<strong2>Postratamiento:</strong2>

• Aplicación de sérum calmante con <strong2>pantenol y ácido hialurónico.</strong2>

</ul>`,
    imagenHero: imagen106,
    imagen1: imagen106,
    imagen2: imagen107,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Mesocapilar",
        cards: [
          { title: "valor sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "90 Min" },
          { title: "Duración", value: "Variable" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Mesocapilar ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "<strong>1. Primeras 24 horas:</strong>\n ✓ Evitar lavado capilar, geles o fijadores.\n ✓ No ejercicio intenso/saunas.<strong>2. Primera semana:</strong>\n✓ Usar protector solar en cuero cabelludo si hay exposición al sol.\n✓ Aplicar ampollas de quinina y argán 3 veces/semana."
        },
        {
          numero: "2",
          titulo:"✖ Contraindicaciones",
          texto: "• Embarazo/lactancia.\n• Infecciones activas en el cuero cabelludo (foliculitis, hongos).\n• Alergias a componentes del cóctel (test previo disponible)."
        },
              
      ],
      videoUrl: imagen108
    }
  },
 "plasma-capilar": {
    id: "plasma-capilar",
    doctor: "DRA. GLADYS EUGENIA QUINTERO CAPERA",
    titulo: "Plasma Capilar con PRP: Regeneración Folicular sin Cirugía",
    titulo1: "Protocolo basado en factores de crecimiento autólogos para combatir la caída del cabello y recuperar la densidad capilar.",
    pregunta: "¿Cómo funciona el Plasma Capilar?",
    descripcion: `<ul><strong>Mecanismo de Acción</strong>
<strong2>✓ Extracción y centrifugado:</strong2>

•Toma de 15-20 ml de sangre venosa.

•Separación de plasma rico en plaquetas (PRP) con concentración 4-6x mayor.
<strong2>✓ Aplicación estratégica:</strong2>

• Microinyecciones en cuero cabelludo con agujas de 30G.

• Liberación de <strong2>PDGF, VEGF y TGF-β</strong2> para reactivar folículos dormidos.

<strong>Beneficios Clave</strong>
<strong2>✓ Bioestimulación folicular:</strong2>

• Aumenta la fase anágena (crecimiento) en un 40%.

• Reduce la caída en un 70% desde la tercera sesión.
<strong2>✓ Mejora estructural:</strong2>

•Cabello más grueso y resistente (aumento de diámetro folicular).

•Regulación de sebo y reducción de descamación.
<strong2>✓ Resultados progresivos:</strong2>

• Efectos visibles a las 8-12 semanas.

• Máximo impacto a los 6 meses (tras 3-4 sesiones).

<strong>Protocolo de Tratamiento</strong>
<strong2>1. Preparación:</strong2>

• Ayuno de 6 horas previas (solo agua permitida).

• Evitar antiinflamatorios × 48 h.

<strong>2. Procedimiento:</strong/>

<strong2>Duración:</strong2> 30-45 minutos.

<strong2>Técnica:</strong2> Infiltración en patrones de rejilla (20-30 puntos/cm²).

<strong2>3. Tecnología:</strong2>

• Tubos de gel de silicio para pureza plaquetaria.

• Equipos de centrifugación certificados.</ul>`,
    imagenHero: imagen109,
    imagen1: imagen109,
    imagen2: imagen110,
  infoCards: [
      {
        sectionTitle: "1. Tratamiento Plasma Capilar",
        cards: [
          { title: "Una sesión", value: "costo de acuerdo a valoración medica" },
          { title: "Aplicación", value: "40 - 60 min" },
          { title: "Duración", value: "12 meses" },
          { title: "Anestesia", value: "Si" },
        ],
      },
    ],
    postOperatorio: {
      titulo: "Cuidados Postratamiento Plasma Capilar ",
      descripcion: "",
      pasos: [
        {
          numero: "1",
          titulo:"✓ Cuidados Postratamiento",
          texto: "<strong>✓ Primeras 24 horas:</strong>\n • No lavar el cabello ni aplicar productos químicos.\n • Evitar ejercicio intenso, saunas o piscinas.\n<strong>✓ Primera semana:</strong>\n  • Usar shampoos sin sulfatos.\n  • Aplicar sérum de pantenol y peptidios para potenciar resultados."
        },
        
        {
          numero: "2",
          titulo:"Recomendaciones Adicionales",
          texto: "▪ Combinar con <strong2>mesoterapia capilar</strong2> o <strong2>minoxidil tópico</strong2> para efectos sinérgicos.\nMantener una dieta rica en <strong2>hierro, zinc y biotina.</strong2>"
        },
        {
          numero: "3",
          titulo:"Contraindicaciones",
          texto: "✖ Embarazo/lactancia.\n✖ Trastornos de coagulación (hemofilia, trombocitopenia).\n✖ Infecciones activas en el cuero cabelludo."
        },
        
        
      ],
      videoUrl: imagen111
    }
  },
 
};